//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AkHeroClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getTopLists(stationID: number | null | undefined): Promise<ScoreTopLists> {
    let url_ = this.baseUrl + '/api/AkHero/getTopLists?';
    if (stationID !== undefined && stationID !== null)
      url_ += 'stationID=' + encodeURIComponent('' + stationID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTopLists(_response);
    });
  }

  protected processGetTopLists(response: Response): Promise<ScoreTopLists> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ScoreTopLists.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ScoreTopLists>(null as any);
  }

  getScoresOverview(
    p_Request: ScoresOverviewRequest
  ): Promise<ScoresOverviewModel> {
    let url_ = this.baseUrl + '/api/AkHero/getScoresOverview';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(p_Request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetScoresOverview(_response);
    });
  }

  protected processGetScoresOverview(
    response: Response
  ): Promise<ScoresOverviewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ScoresOverviewModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ScoresOverviewModel>(null as any);
  }

  getWeeklyDriverHighlights(): Promise<ScoresOverviewModel> {
    let url_ = this.baseUrl + '/api/AkHero/getWeeklyDriverHighlights';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetWeeklyDriverHighlights(_response);
    });
  }

  protected processGetWeeklyDriverHighlights(
    response: Response
  ): Promise<ScoresOverviewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ScoresOverviewModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ScoresOverviewModel>(null as any);
  }

  getThumbnailDriverProfilePicture(id: number): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/AkHero/driverProfile/thumbnail/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetThumbnailDriverProfilePicture(_response);
    });
  }

  protected processGetThumbnailDriverProfilePicture(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }

  getFullSizeDriverProfilePicture(id: number): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/AkHero/driverProfile/fullSize/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFullSizeDriverProfilePicture(_response);
    });
  }

  protected processGetFullSizeDriverProfilePicture(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }
}

export class DashboardClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getDashboardStats(
    stationID: number | null | undefined
  ): Promise<DashboardStats> {
    let url_ = this.baseUrl + '/api/Dashboard/GetDashboardStats?';
    if (stationID !== undefined && stationID !== null)
      url_ += 'stationID=' + encodeURIComponent('' + stationID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetDashboardStats(_response);
    });
  }

  protected processGetDashboardStats(
    response: Response
  ): Promise<DashboardStats> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DashboardStats.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DashboardStats>(null as any);
  }

  getTodaysCompletedTowingCount(
    stationID: number | null | undefined
  ): Promise<number> {
    let url_ = this.baseUrl + '/api/Dashboard/GetTodaysCompletedTowingCount?';
    if (stationID !== undefined && stationID !== null)
      url_ += 'stationID=' + encodeURIComponent('' + stationID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTodaysCompletedTowingCount(_response);
    });
  }

  protected processGetTodaysCompletedTowingCount(
    response: Response
  ): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<number>(null as any);
  }
}

export class StationCoverageClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getSetup(): Promise<StationCoverageSetup> {
    let url_ = this.baseUrl + '/api/StationCoverage/GetSetup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSetup(_response);
    });
  }

  protected processGetSetup(response: Response): Promise<StationCoverageSetup> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StationCoverageSetup.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationCoverageSetup>(null as any);
  }

  getActiveSets(): Promise<StationCoverageSetModel[]> {
    let url_ = this.baseUrl + '/api/StationCoverage/GetActiveSets';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetActiveSets(_response);
    });
  }

  protected processGetActiveSets(
    response: Response
  ): Promise<StationCoverageSetModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(StationCoverageSetModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationCoverageSetModel[]>(null as any);
  }

  calculateStationCoverage(
    p_Request: StationCoverageSetModel
  ): Promise<StationCoverageResult> {
    let url_ = this.baseUrl + '/api/StationCoverage/CalculateStationCoverage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(p_Request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCalculateStationCoverage(_response);
    });
  }

  protected processCalculateStationCoverage(
    response: Response
  ): Promise<StationCoverageResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StationCoverageResult.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationCoverageResult>(null as any);
  }

  saveStationCoverageSet(
    p_Request: StationCoverageSetModel
  ): Promise<SaveStationCoverageSetResult> {
    let url_ = this.baseUrl + '/api/StationCoverage/SaveStationCoverageSet';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(p_Request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSaveStationCoverageSet(_response);
    });
  }

  protected processSaveStationCoverageSet(
    response: Response
  ): Promise<SaveStationCoverageSetResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SaveStationCoverageSetResult.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SaveStationCoverageSetResult>(null as any);
  }

  disableStationCoverageSet(p_ID: number): Promise<void> {
    let url_ =
      this.baseUrl + '/api/StationCoverage/DisableStationCoverageSet/{p_ID}';
    if (p_ID === undefined || p_ID === null)
      throw new Error("The parameter 'p_ID' must be defined.");
    url_ = url_.replace('{p_ID}', encodeURIComponent('' + p_ID));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDisableStationCoverageSet(_response);
    });
  }

  protected processDisableStationCoverageSet(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class StatsClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getStatsSet(p_Request: StatsRequestModel): Promise<StatsSetModel> {
    let url_ = this.baseUrl + '/api/Stats/StatsSet';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(p_Request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStatsSet(_response);
    });
  }

  protected processGetStatsSet(response: Response): Promise<StatsSetModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StatsSetModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StatsSetModel>(null as any);
  }

  getAllYearlyReports(): Promise<YearlyReportsModel[]> {
    let url_ = this.baseUrl + '/api/Stats/GetAllYearlyReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllYearlyReports(_response);
    });
  }

  protected processGetAllYearlyReports(
    response: Response
  ): Promise<YearlyReportsModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(YearlyReportsModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<YearlyReportsModel[]>(null as any);
  }

  getAllQuarterlyReports(): Promise<QuarterlyReportsModel[]> {
    let url_ = this.baseUrl + '/api/Stats/GetAllQuarterlyReports';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllQuarterlyReports(_response);
    });
  }

  protected processGetAllQuarterlyReports(
    response: Response
  ): Promise<QuarterlyReportsModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(QuarterlyReportsModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<QuarterlyReportsModel[]>(null as any);
  }

  getInvoiceStats(p_Request: InvoiceStatsRequestModel): Promise<StatsSetModel> {
    let url_ = this.baseUrl + '/api/Stats/InvoiceStatsSet';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(p_Request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInvoiceStats(_response);
    });
  }

  protected processGetInvoiceStats(response: Response): Promise<StatsSetModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StatsSetModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StatsSetModel>(null as any);
  }

  getActiveCasesExcel(id: string): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Stats/DownloadExcel/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetActiveCasesExcel(_response);
    });
  }

  protected processGetActiveCasesExcel(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }
}

export class AuthenticationClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  initiateBankIDLogin(): Promise<BankSignInitiationResponse> {
    let url_ = this.baseUrl + '/api/Authentication/InitiateBankIDLogin';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processInitiateBankIDLogin(_response);
    });
  }

  protected processInitiateBankIDLogin(
    response: Response
  ): Promise<BankSignInitiationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BankSignInitiationResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BankSignInitiationResponse>(null as any);
  }

  pollBankIDLoginStatus(
    model: BankSignRequest
  ): Promise<BankSignCollectResponse> {
    let url_ = this.baseUrl + '/api/Authentication/PollBankIDLoginStatus';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPollBankIDLoginStatus(_response);
    });
  }

  protected processPollBankIDLoginStatus(
    response: Response
  ): Promise<BankSignCollectResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BankSignCollectResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BankSignCollectResponse>(null as any);
  }

  refreshJwtToken(
    jwtToken: string | undefined,
    jwtRefreshToken: string | undefined
  ): Promise<RefreshJwtTokenResponse> {
    let url_ = this.baseUrl + '/api/Authentication/RefreshJwtToken?';
    if (jwtToken === null)
      throw new Error("The parameter 'jwtToken' cannot be null.");
    else if (jwtToken !== undefined)
      url_ += 'jwtToken=' + encodeURIComponent('' + jwtToken) + '&';
    if (jwtRefreshToken === null)
      throw new Error("The parameter 'jwtRefreshToken' cannot be null.");
    else if (jwtRefreshToken !== undefined)
      url_ +=
        'jwtRefreshToken=' + encodeURIComponent('' + jwtRefreshToken) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRefreshJwtToken(_response);
    });
  }

  protected processRefreshJwtToken(
    response: Response
  ): Promise<RefreshJwtTokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RefreshJwtTokenResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<RefreshJwtTokenResponse>(null as any);
  }

  logoutUser(): Promise<void> {
    let url_ = this.baseUrl + '/api/Authentication/LogoutUser';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processLogoutUser(_response);
    });
  }

  protected processLogoutUser(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class DEVONLYClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  signInUser(
    socialSecurityNumber: string | undefined
  ): Promise<BankSignCollectResponse> {
    let url_ = this.baseUrl + '/api/Authentication/DEVONLY_signInUser?';
    if (socialSecurityNumber === null)
      throw new Error("The parameter 'socialSecurityNumber' cannot be null.");
    else if (socialSecurityNumber !== undefined)
      url_ +=
        'socialSecurityNumber=' +
        encodeURIComponent('' + socialSecurityNumber) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSignInUser(_response);
    });
  }

  protected processSignInUser(
    response: Response
  ): Promise<BankSignCollectResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BankSignCollectResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BankSignCollectResponse>(null as any);
  }
}

export class BasicDataClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getBasicData(): Promise<BasicDataModel> {
    let url_ = this.baseUrl + '/api/BasicData/get';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBasicData(_response);
    });
  }

  protected processGetBasicData(response: Response): Promise<BasicDataModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BasicDataModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BasicDataModel>(null as any);
  }

  requsetRefresh(): Promise<BasicDataModel> {
    let url_ = this.baseUrl + '/api/BasicData/request-refresh';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRequsetRefresh(_response);
    });
  }

  protected processRequsetRefresh(response: Response): Promise<BasicDataModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BasicDataModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BasicDataModel>(null as any);
  }
}

export class UserClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getMe(): Promise<WebUser> {
    let url_ = this.baseUrl + '/api/User/me';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetMe(_response);
    });
  }

  protected processGetMe(response: Response): Promise<WebUser> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WebUser.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebUser>(null as any);
  }

  getBySocialSecurityNumber(ssn: string): Promise<WebUser> {
    let url_ = this.baseUrl + '/api/User/by-ssn/{ssn}';
    if (ssn === undefined || ssn === null)
      throw new Error("The parameter 'ssn' must be defined.");
    url_ = url_.replace('{ssn}', encodeURIComponent('' + ssn));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetBySocialSecurityNumber(_response);
    });
  }

  protected processGetBySocialSecurityNumber(
    response: Response
  ): Promise<WebUser> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WebUser.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebUser>(null as any);
  }

  getById(id: number): Promise<WebUser> {
    let url_ = this.baseUrl + '/api/User/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetById(_response);
    });
  }

  protected processGetById(response: Response): Promise<WebUser> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WebUser.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebUser>(null as any);
  }

  updateUser(id: number, webUser: WebUser): Promise<WebUser> {
    let url_ = this.baseUrl + '/api/User/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(webUser);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateUser(_response);
    });
  }

  protected processUpdateUser(response: Response): Promise<WebUser> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WebUser.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebUser>(null as any);
  }

  createUser(webUser: WebUser): Promise<WebUser> {
    let url_ = this.baseUrl + '/api/User/create';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(webUser);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateUser(_response);
    });
  }

  protected processCreateUser(response: Response): Promise<WebUser> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = WebUser.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebUser>(null as any);
  }

  setIsLinkedToStation(
    userId: number,
    stationId: number,
    hasLink: boolean
  ): Promise<void> {
    let url_ =
      this.baseUrl + '/api/User/{userId}/has-link-to-station/{stationId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(hasLink);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSetIsLinkedToStation(_response);
    });
  }

  protected processSetIsLinkedToStation(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getByStation(stationId: number): Promise<WebUser[]> {
    let url_ = this.baseUrl + '/api/User/byStation/{stationId}';
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetByStation(_response);
    });
  }

  protected processGetByStation(response: Response): Promise<WebUser[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(WebUser.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebUser[]>(null as any);
  }

  getAll(): Promise<WebUser[]> {
    let url_ = this.baseUrl + '/api/User/all';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAll(_response);
    });
  }

  protected processGetAll(response: Response): Promise<WebUser[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(WebUser.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebUser[]>(null as any);
  }
}

export class AssistEventClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  index(request: any): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/AssistEvent';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processIndex(_response);
    });
  }

  protected processIndex(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }
}

export class GroupSetAdminClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  addGroupSet(
    p_IdType: IdType | undefined,
    p_SetName: string | undefined
  ): Promise<GroupSet> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/AddGroupSet?';
    if (p_IdType === null)
      throw new Error("The parameter 'p_IdType' cannot be null.");
    else if (p_IdType !== undefined)
      url_ += 'p_IdType=' + encodeURIComponent('' + p_IdType) + '&';
    if (p_SetName === null)
      throw new Error("The parameter 'p_SetName' cannot be null.");
    else if (p_SetName !== undefined)
      url_ += 'p_SetName=' + encodeURIComponent('' + p_SetName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddGroupSet(_response);
    });
  }

  protected processAddGroupSet(response: Response): Promise<GroupSet> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GroupSet.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GroupSet>(null as any);
  }

  disableGroupSet(p_GroupSetID: number | undefined): Promise<GroupSet> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/DisableGroupSet?';
    if (p_GroupSetID === null)
      throw new Error("The parameter 'p_GroupSetID' cannot be null.");
    else if (p_GroupSetID !== undefined)
      url_ += 'p_GroupSetID=' + encodeURIComponent('' + p_GroupSetID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDisableGroupSet(_response);
    });
  }

  protected processDisableGroupSet(response: Response): Promise<GroupSet> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GroupSet.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GroupSet>(null as any);
  }

  renameGroupSet(
    p_GroupSetID: number | undefined,
    p_SetName: string | undefined
  ): Promise<GroupSet> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/RenameGroupSet?';
    if (p_GroupSetID === null)
      throw new Error("The parameter 'p_GroupSetID' cannot be null.");
    else if (p_GroupSetID !== undefined)
      url_ += 'p_GroupSetID=' + encodeURIComponent('' + p_GroupSetID) + '&';
    if (p_SetName === null)
      throw new Error("The parameter 'p_SetName' cannot be null.");
    else if (p_SetName !== undefined)
      url_ += 'p_SetName=' + encodeURIComponent('' + p_SetName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRenameGroupSet(_response);
    });
  }

  protected processRenameGroupSet(response: Response): Promise<GroupSet> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GroupSet.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GroupSet>(null as any);
  }

  addGroup(
    p_GroupSetID: number | undefined,
    p_GroupName: string | undefined
  ): Promise<Group> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/AddGroup?';
    if (p_GroupSetID === null)
      throw new Error("The parameter 'p_GroupSetID' cannot be null.");
    else if (p_GroupSetID !== undefined)
      url_ += 'p_GroupSetID=' + encodeURIComponent('' + p_GroupSetID) + '&';
    if (p_GroupName === null)
      throw new Error("The parameter 'p_GroupName' cannot be null.");
    else if (p_GroupName !== undefined)
      url_ += 'p_GroupName=' + encodeURIComponent('' + p_GroupName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddGroup(_response);
    });
  }

  protected processAddGroup(response: Response): Promise<Group> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = Group.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Group>(null as any);
  }

  removeGroup(p_GroupID: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/RemoveGroup?';
    if (p_GroupID === null)
      throw new Error("The parameter 'p_GroupID' cannot be null.");
    else if (p_GroupID !== undefined)
      url_ += 'p_GroupID=' + encodeURIComponent('' + p_GroupID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveGroup(_response);
    });
  }

  protected processRemoveGroup(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  renameGroup(
    p_GroupID: number | undefined,
    p_GroupName: string | undefined
  ): Promise<Group> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/RenameGroup?';
    if (p_GroupID === null)
      throw new Error("The parameter 'p_GroupID' cannot be null.");
    else if (p_GroupID !== undefined)
      url_ += 'p_GroupID=' + encodeURIComponent('' + p_GroupID) + '&';
    if (p_GroupName === null)
      throw new Error("The parameter 'p_GroupName' cannot be null.");
    else if (p_GroupName !== undefined)
      url_ += 'p_GroupName=' + encodeURIComponent('' + p_GroupName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRenameGroup(_response);
    });
  }

  protected processRenameGroup(response: Response): Promise<Group> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = Group.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Group>(null as any);
  }

  addGroupItems(
    p_GroupID: number | undefined,
    p_ItemIDs: number[]
  ): Promise<GroupItem[]> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/AddGroupItems?';
    if (p_GroupID === null)
      throw new Error("The parameter 'p_GroupID' cannot be null.");
    else if (p_GroupID !== undefined)
      url_ += 'p_GroupID=' + encodeURIComponent('' + p_GroupID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(p_ItemIDs);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddGroupItems(_response);
    });
  }

  protected processAddGroupItems(response: Response): Promise<GroupItem[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(GroupItem.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GroupItem[]>(null as any);
  }

  removeGroupItem(
    p_GroupID: number | undefined,
    p_ItemID: number | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/RemoveGroupItem?';
    if (p_GroupID === null)
      throw new Error("The parameter 'p_GroupID' cannot be null.");
    else if (p_GroupID !== undefined)
      url_ += 'p_GroupID=' + encodeURIComponent('' + p_GroupID) + '&';
    if (p_ItemID === null)
      throw new Error("The parameter 'p_ItemID' cannot be null.");
    else if (p_ItemID !== undefined)
      url_ += 'p_ItemID=' + encodeURIComponent('' + p_ItemID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveGroupItem(_response);
    });
  }

  protected processRemoveGroupItem(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getGroupSetsByIdType(): Promise<
    { [key in keyof typeof IdType]?: GroupSet[] }
  > {
    let url_ = this.baseUrl + '/api/GroupSetAdmin/GetGroupSetsByIdType';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetGroupSetsByIdType(_response);
    });
  }

  protected processGetGroupSetsByIdType(
    response: Response
  ): Promise<{ [key in keyof typeof IdType]?: GroupSet[] }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (resultData200) {
          result200 = {} as any;
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key))
              (<any>result200)![key] = resultData200[key]
                ? resultData200[key].map((i: any) => GroupSet.fromJS(i))
                : [];
          }
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<{ [key in keyof typeof IdType]?: GroupSet[] }>(
      null as any
    );
  }
}

export class ScoreTopLists implements IScoreTopLists {
  topListsInfoText!: string;
  stationRankings!: TopListScore[];
  driverRankings_AllOfAk!: TopListScore[];
  stationID?: number | undefined;
  driverRankings_ForStationID!: TopListScore[];

  constructor(data?: IScoreTopLists) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.stationRankings = [];
      this.driverRankings_AllOfAk = [];
      this.driverRankings_ForStationID = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.topListsInfoText = _data['topListsInfoText'];
      if (Array.isArray(_data['stationRankings'])) {
        this.stationRankings = [] as any;
        for (let item of _data['stationRankings'])
          this.stationRankings!.push(TopListScore.fromJS(item));
      }
      if (Array.isArray(_data['driverRankings_AllOfAk'])) {
        this.driverRankings_AllOfAk = [] as any;
        for (let item of _data['driverRankings_AllOfAk'])
          this.driverRankings_AllOfAk!.push(TopListScore.fromJS(item));
      }
      this.stationID = _data['stationID'];
      if (Array.isArray(_data['driverRankings_ForStationID'])) {
        this.driverRankings_ForStationID = [] as any;
        for (let item of _data['driverRankings_ForStationID'])
          this.driverRankings_ForStationID!.push(TopListScore.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ScoreTopLists {
    data = typeof data === 'object' ? data : {};
    let result = new ScoreTopLists();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['topListsInfoText'] = this.topListsInfoText;
    if (Array.isArray(this.stationRankings)) {
      data['stationRankings'] = [];
      for (let item of this.stationRankings)
        data['stationRankings'].push(item.toJSON());
    }
    if (Array.isArray(this.driverRankings_AllOfAk)) {
      data['driverRankings_AllOfAk'] = [];
      for (let item of this.driverRankings_AllOfAk)
        data['driverRankings_AllOfAk'].push(item.toJSON());
    }
    data['stationID'] = this.stationID;
    if (Array.isArray(this.driverRankings_ForStationID)) {
      data['driverRankings_ForStationID'] = [];
      for (let item of this.driverRankings_ForStationID)
        data['driverRankings_ForStationID'].push(item.toJSON());
    }
    return data;
  }
}

export interface IScoreTopLists {
  topListsInfoText: string;
  stationRankings: TopListScore[];
  driverRankings_AllOfAk: TopListScore[];
  stationID?: number | undefined;
  driverRankings_ForStationID: TopListScore[];
}

export class TopListScore implements ITopListScore {
  name!: string;
  totalScore!: number;
  scoreLevel!: ScoreLevel;

  constructor(data?: ITopListScore) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.totalScore = _data['totalScore'];
      this.scoreLevel = _data['scoreLevel'];
    }
  }

  static fromJS(data: any): TopListScore {
    data = typeof data === 'object' ? data : {};
    let result = new TopListScore();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['totalScore'] = this.totalScore;
    data['scoreLevel'] = this.scoreLevel;
    return data;
  }
}

export interface ITopListScore {
  name: string;
  totalScore: number;
  scoreLevel: ScoreLevel;
}

export enum ScoreLevel {
  Unranked = 100,
  Bronze = 200,
  Siver = 300,
  Gold = 400,
  Hero = 500,
}

export class ScoresOverviewModel implements IScoresOverviewModel {
  summary!: string;
  columnSettings!: Column[];
  rows!: Cell[][];

  constructor(data?: IScoresOverviewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.columnSettings = [];
      this.rows = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.summary = _data['summary'];
      if (Array.isArray(_data['columnSettings'])) {
        this.columnSettings = [] as any;
        for (let item of _data['columnSettings'])
          this.columnSettings!.push(Column.fromJS(item));
      }
      if (Array.isArray(_data['rows'])) {
        this.rows = [] as any;
        for (let item of _data['rows']) this.rows!.push(item);
      }
    }
  }

  static fromJS(data: any): ScoresOverviewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ScoresOverviewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['summary'] = this.summary;
    if (Array.isArray(this.columnSettings)) {
      data['columnSettings'] = [];
      for (let item of this.columnSettings)
        data['columnSettings'].push(item.toJSON());
    }
    if (Array.isArray(this.rows)) {
      data['rows'] = [];
      for (let item of this.rows) data['rows'].push(item);
    }
    return data;
  }
}

export interface IScoresOverviewModel {
  summary: string;
  columnSettings: Column[];
  rows: Cell[][];
}

export class Column implements IColumn {
  header!: string;
  columnWidth?: string | undefined;
  sortByValue!: boolean;
  columnType!: ColumnType;

  constructor(data?: IColumn) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.header = _data['header'];
      this.columnWidth = _data['columnWidth'];
      this.sortByValue = _data['sortByValue'];
      this.columnType = _data['columnType'];
    }
  }

  static fromJS(data: any): Column {
    data = typeof data === 'object' ? data : {};
    let result = new Column();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['header'] = this.header;
    data['columnWidth'] = this.columnWidth;
    data['sortByValue'] = this.sortByValue;
    data['columnType'] = this.columnType;
    return data;
  }
}

export interface IColumn {
  header: string;
  columnWidth?: string | undefined;
  sortByValue: boolean;
  columnType: ColumnType;
}

export enum ColumnType {
  Regular = 1,
  DriverInfo = 2,
}

export class Cell implements ICell {
  d?: string | undefined;
  v!: number;

  constructor(data?: ICell) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.d = _data['d'];
      this.v = _data['v'];
    }
  }

  static fromJS(data: any): Cell {
    data = typeof data === 'object' ? data : {};
    let result = new Cell();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['d'] = this.d;
    data['v'] = this.v;
    return data;
  }
}

export interface ICell {
  d?: string | undefined;
  v: number;
}

export class ScoresOverviewRequest implements IScoresOverviewRequest {
  scoreCategory!: ScoreCategory;
  isStationScores!: boolean;

  constructor(data?: IScoresOverviewRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scoreCategory = _data['scoreCategory'];
      this.isStationScores = _data['isStationScores'];
    }
  }

  static fromJS(data: any): ScoresOverviewRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ScoresOverviewRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['scoreCategory'] = this.scoreCategory;
    data['isStationScores'] = this.isStationScores;
    return data;
  }
}

export interface IScoresOverviewRequest {
  scoreCategory: ScoreCategory;
  isStationScores: boolean;
}

export enum ScoreCategory {
  Live = 1,
}

export class DashboardStats implements IDashboardStats {
  statsInfoText!: string;
  yearlyStats!: DashboardYearStats[];
  monthlyStats!: DashboardMonthStats[];
  weeklyStats!: DashboardWeekStats[];
  inboundStats!: DashboardInboundStats;

  constructor(data?: IDashboardStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.yearlyStats = [];
      this.monthlyStats = [];
      this.weeklyStats = [];
      this.inboundStats = new DashboardInboundStats();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.statsInfoText = _data['statsInfoText'];
      if (Array.isArray(_data['yearlyStats'])) {
        this.yearlyStats = [] as any;
        for (let item of _data['yearlyStats'])
          this.yearlyStats!.push(DashboardYearStats.fromJS(item));
      }
      if (Array.isArray(_data['monthlyStats'])) {
        this.monthlyStats = [] as any;
        for (let item of _data['monthlyStats'])
          this.monthlyStats!.push(DashboardMonthStats.fromJS(item));
      }
      if (Array.isArray(_data['weeklyStats'])) {
        this.weeklyStats = [] as any;
        for (let item of _data['weeklyStats'])
          this.weeklyStats!.push(DashboardWeekStats.fromJS(item));
      }
      this.inboundStats = _data['inboundStats']
        ? DashboardInboundStats.fromJS(_data['inboundStats'])
        : new DashboardInboundStats();
    }
  }

  static fromJS(data: any): DashboardStats {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardStats();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['statsInfoText'] = this.statsInfoText;
    if (Array.isArray(this.yearlyStats)) {
      data['yearlyStats'] = [];
      for (let item of this.yearlyStats)
        data['yearlyStats'].push(item.toJSON());
    }
    if (Array.isArray(this.monthlyStats)) {
      data['monthlyStats'] = [];
      for (let item of this.monthlyStats)
        data['monthlyStats'].push(item.toJSON());
    }
    if (Array.isArray(this.weeklyStats)) {
      data['weeklyStats'] = [];
      for (let item of this.weeklyStats)
        data['weeklyStats'].push(item.toJSON());
    }
    data['inboundStats'] = this.inboundStats
      ? this.inboundStats.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IDashboardStats {
  statsInfoText: string;
  yearlyStats: DashboardYearStats[];
  monthlyStats: DashboardMonthStats[];
  weeklyStats: DashboardWeekStats[];
  inboundStats: DashboardInboundStats;
}

export class DashboardYearStats implements IDashboardYearStats {
  year!: number;
  completedTowingCount!: ComparisonDataPoint;
  invoicedTowingCount!: ComparisonDataPoint;
  heavyVehiclesCount!: ComparisonDataPoint;
  totalSalesPrice!: ComparisonDataPoint;
  projectedAdditionalTowingCount!: number;
  projectedAdditionalSalesPrice!: number;

  constructor(data?: IDashboardYearStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.completedTowingCount = new ComparisonDataPoint();
      this.invoicedTowingCount = new ComparisonDataPoint();
      this.heavyVehiclesCount = new ComparisonDataPoint();
      this.totalSalesPrice = new ComparisonDataPoint();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data['year'];
      this.completedTowingCount = _data['completedTowingCount']
        ? ComparisonDataPoint.fromJS(_data['completedTowingCount'])
        : new ComparisonDataPoint();
      this.invoicedTowingCount = _data['invoicedTowingCount']
        ? ComparisonDataPoint.fromJS(_data['invoicedTowingCount'])
        : new ComparisonDataPoint();
      this.heavyVehiclesCount = _data['heavyVehiclesCount']
        ? ComparisonDataPoint.fromJS(_data['heavyVehiclesCount'])
        : new ComparisonDataPoint();
      this.totalSalesPrice = _data['totalSalesPrice']
        ? ComparisonDataPoint.fromJS(_data['totalSalesPrice'])
        : new ComparisonDataPoint();
      this.projectedAdditionalTowingCount =
        _data['projectedAdditionalTowingCount'];
      this.projectedAdditionalSalesPrice =
        _data['projectedAdditionalSalesPrice'];
    }
  }

  static fromJS(data: any): DashboardYearStats {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardYearStats();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['year'] = this.year;
    data['completedTowingCount'] = this.completedTowingCount
      ? this.completedTowingCount.toJSON()
      : <any>undefined;
    data['invoicedTowingCount'] = this.invoicedTowingCount
      ? this.invoicedTowingCount.toJSON()
      : <any>undefined;
    data['heavyVehiclesCount'] = this.heavyVehiclesCount
      ? this.heavyVehiclesCount.toJSON()
      : <any>undefined;
    data['totalSalesPrice'] = this.totalSalesPrice
      ? this.totalSalesPrice.toJSON()
      : <any>undefined;
    data[
      'projectedAdditionalTowingCount'
    ] = this.projectedAdditionalTowingCount;
    data['projectedAdditionalSalesPrice'] = this.projectedAdditionalSalesPrice;
    return data;
  }
}

export interface IDashboardYearStats {
  year: number;
  completedTowingCount: ComparisonDataPoint;
  invoicedTowingCount: ComparisonDataPoint;
  heavyVehiclesCount: ComparisonDataPoint;
  totalSalesPrice: ComparisonDataPoint;
  projectedAdditionalTowingCount: number;
  projectedAdditionalSalesPrice: number;
}

export class ComparisonDataPoint implements IComparisonDataPoint {
  value!: number;
  previousYearValue!: number;
  topValue!: number;
  yearOfTopValue!: number;

  constructor(data?: IComparisonDataPoint) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data['value'];
      this.previousYearValue = _data['previousYearValue'];
      this.topValue = _data['topValue'];
      this.yearOfTopValue = _data['yearOfTopValue'];
    }
  }

  static fromJS(data: any): ComparisonDataPoint {
    data = typeof data === 'object' ? data : {};
    let result = new ComparisonDataPoint();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['value'] = this.value;
    data['previousYearValue'] = this.previousYearValue;
    data['topValue'] = this.topValue;
    data['yearOfTopValue'] = this.yearOfTopValue;
    return data;
  }
}

export interface IComparisonDataPoint {
  value: number;
  previousYearValue: number;
  topValue: number;
  yearOfTopValue: number;
}

export class DashboardMonthStats implements IDashboardMonthStats {
  month!: MonthAndYearModel;
  completedTowingCount!: ComparisonDataPoint;
  invoicedTowingCount!: ComparisonDataPoint;
  heavyVehiclesCount!: ComparisonDataPoint;
  totalSalesPrice!: ComparisonDataPoint;
  projectedAdditionalTowingCount!: number;
  projectedAdditionalSalesPrice!: number;

  constructor(data?: IDashboardMonthStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.month = new MonthAndYearModel();
      this.completedTowingCount = new ComparisonDataPoint();
      this.invoicedTowingCount = new ComparisonDataPoint();
      this.heavyVehiclesCount = new ComparisonDataPoint();
      this.totalSalesPrice = new ComparisonDataPoint();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.month = _data['month']
        ? MonthAndYearModel.fromJS(_data['month'])
        : new MonthAndYearModel();
      this.completedTowingCount = _data['completedTowingCount']
        ? ComparisonDataPoint.fromJS(_data['completedTowingCount'])
        : new ComparisonDataPoint();
      this.invoicedTowingCount = _data['invoicedTowingCount']
        ? ComparisonDataPoint.fromJS(_data['invoicedTowingCount'])
        : new ComparisonDataPoint();
      this.heavyVehiclesCount = _data['heavyVehiclesCount']
        ? ComparisonDataPoint.fromJS(_data['heavyVehiclesCount'])
        : new ComparisonDataPoint();
      this.totalSalesPrice = _data['totalSalesPrice']
        ? ComparisonDataPoint.fromJS(_data['totalSalesPrice'])
        : new ComparisonDataPoint();
      this.projectedAdditionalTowingCount =
        _data['projectedAdditionalTowingCount'];
      this.projectedAdditionalSalesPrice =
        _data['projectedAdditionalSalesPrice'];
    }
  }

  static fromJS(data: any): DashboardMonthStats {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardMonthStats();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['month'] = this.month ? this.month.toJSON() : <any>undefined;
    data['completedTowingCount'] = this.completedTowingCount
      ? this.completedTowingCount.toJSON()
      : <any>undefined;
    data['invoicedTowingCount'] = this.invoicedTowingCount
      ? this.invoicedTowingCount.toJSON()
      : <any>undefined;
    data['heavyVehiclesCount'] = this.heavyVehiclesCount
      ? this.heavyVehiclesCount.toJSON()
      : <any>undefined;
    data['totalSalesPrice'] = this.totalSalesPrice
      ? this.totalSalesPrice.toJSON()
      : <any>undefined;
    data[
      'projectedAdditionalTowingCount'
    ] = this.projectedAdditionalTowingCount;
    data['projectedAdditionalSalesPrice'] = this.projectedAdditionalSalesPrice;
    return data;
  }
}

export interface IDashboardMonthStats {
  month: MonthAndYearModel;
  completedTowingCount: ComparisonDataPoint;
  invoicedTowingCount: ComparisonDataPoint;
  heavyVehiclesCount: ComparisonDataPoint;
  totalSalesPrice: ComparisonDataPoint;
  projectedAdditionalTowingCount: number;
  projectedAdditionalSalesPrice: number;
}

export class MonthAndYearModel implements IMonthAndYearModel {
  year!: number;
  month!: number;

  constructor(data?: IMonthAndYearModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data['year'];
      this.month = _data['month'];
    }
  }

  static fromJS(data: any): MonthAndYearModel {
    data = typeof data === 'object' ? data : {};
    let result = new MonthAndYearModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['year'] = this.year;
    data['month'] = this.month;
    return data;
  }
}

export interface IMonthAndYearModel {
  year: number;
  month: number;
}

export class DashboardWeekStats implements IDashboardWeekStats {
  week!: WeekAndYearModel;
  completedTowingCount!: ComparisonDataPoint;
  invoicedTowingCount!: ComparisonDataPoint;
  heavyVehiclesCount!: ComparisonDataPoint;
  totalSalesPrice!: ComparisonDataPoint;
  projectedAdditionalTowingCount!: number;
  projectedAdditionalSalesPrice!: number;

  constructor(data?: IDashboardWeekStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.week = new WeekAndYearModel();
      this.completedTowingCount = new ComparisonDataPoint();
      this.invoicedTowingCount = new ComparisonDataPoint();
      this.heavyVehiclesCount = new ComparisonDataPoint();
      this.totalSalesPrice = new ComparisonDataPoint();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.week = _data['week']
        ? WeekAndYearModel.fromJS(_data['week'])
        : new WeekAndYearModel();
      this.completedTowingCount = _data['completedTowingCount']
        ? ComparisonDataPoint.fromJS(_data['completedTowingCount'])
        : new ComparisonDataPoint();
      this.invoicedTowingCount = _data['invoicedTowingCount']
        ? ComparisonDataPoint.fromJS(_data['invoicedTowingCount'])
        : new ComparisonDataPoint();
      this.heavyVehiclesCount = _data['heavyVehiclesCount']
        ? ComparisonDataPoint.fromJS(_data['heavyVehiclesCount'])
        : new ComparisonDataPoint();
      this.totalSalesPrice = _data['totalSalesPrice']
        ? ComparisonDataPoint.fromJS(_data['totalSalesPrice'])
        : new ComparisonDataPoint();
      this.projectedAdditionalTowingCount =
        _data['projectedAdditionalTowingCount'];
      this.projectedAdditionalSalesPrice =
        _data['projectedAdditionalSalesPrice'];
    }
  }

  static fromJS(data: any): DashboardWeekStats {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardWeekStats();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['week'] = this.week ? this.week.toJSON() : <any>undefined;
    data['completedTowingCount'] = this.completedTowingCount
      ? this.completedTowingCount.toJSON()
      : <any>undefined;
    data['invoicedTowingCount'] = this.invoicedTowingCount
      ? this.invoicedTowingCount.toJSON()
      : <any>undefined;
    data['heavyVehiclesCount'] = this.heavyVehiclesCount
      ? this.heavyVehiclesCount.toJSON()
      : <any>undefined;
    data['totalSalesPrice'] = this.totalSalesPrice
      ? this.totalSalesPrice.toJSON()
      : <any>undefined;
    data[
      'projectedAdditionalTowingCount'
    ] = this.projectedAdditionalTowingCount;
    data['projectedAdditionalSalesPrice'] = this.projectedAdditionalSalesPrice;
    return data;
  }
}

export interface IDashboardWeekStats {
  week: WeekAndYearModel;
  completedTowingCount: ComparisonDataPoint;
  invoicedTowingCount: ComparisonDataPoint;
  heavyVehiclesCount: ComparisonDataPoint;
  totalSalesPrice: ComparisonDataPoint;
  projectedAdditionalTowingCount: number;
  projectedAdditionalSalesPrice: number;
}

export class WeekAndYearModel implements IWeekAndYearModel {
  yearByISOWeekNumbering!: number;
  weekNumber!: number;

  constructor(data?: IWeekAndYearModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.yearByISOWeekNumbering = _data['yearByISOWeekNumbering'];
      this.weekNumber = _data['weekNumber'];
    }
  }

  static fromJS(data: any): WeekAndYearModel {
    data = typeof data === 'object' ? data : {};
    let result = new WeekAndYearModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['yearByISOWeekNumbering'] = this.yearByISOWeekNumbering;
    data['weekNumber'] = this.weekNumber;
    return data;
  }
}

export interface IWeekAndYearModel {
  yearByISOWeekNumbering: number;
  weekNumber: number;
}

export class DashboardInboundStats implements IDashboardInboundStats {
  infoText!: string;
  totalRevenue!: string;
  rows!: DashboardInboundStatsRow[];

  constructor(data?: IDashboardInboundStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.rows = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.infoText = _data['infoText'];
      this.totalRevenue = _data['totalRevenue'];
      if (Array.isArray(_data['rows'])) {
        this.rows = [] as any;
        for (let item of _data['rows'])
          this.rows!.push(DashboardInboundStatsRow.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DashboardInboundStats {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardInboundStats();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['infoText'] = this.infoText;
    data['totalRevenue'] = this.totalRevenue;
    if (Array.isArray(this.rows)) {
      data['rows'] = [];
      for (let item of this.rows) data['rows'].push(item.toJSON());
    }
    return data;
  }
}

export interface IDashboardInboundStats {
  infoText: string;
  totalRevenue: string;
  rows: DashboardInboundStatsRow[];
}

export class DashboardInboundStatsRow implements IDashboardInboundStatsRow {
  inboundName!: string;
  assignmentCount!: number;
  revenue!: number;

  constructor(data?: IDashboardInboundStatsRow) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.inboundName = _data['inboundName'];
      this.assignmentCount = _data['assignmentCount'];
      this.revenue = _data['revenue'];
    }
  }

  static fromJS(data: any): DashboardInboundStatsRow {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardInboundStatsRow();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['inboundName'] = this.inboundName;
    data['assignmentCount'] = this.assignmentCount;
    data['revenue'] = this.revenue;
    return data;
  }
}

export interface IDashboardInboundStatsRow {
  inboundName: string;
  assignmentCount: number;
  revenue: number;
}

export class StationCoverageSetup implements IStationCoverageSetup {
  dateRange!: DateRange;
  totalNrOfDays!: number;
  returnLocationInfoByID!: { [key: string]: ReturnLocationInfo };
  originalAggregates!: StationCoverageAggregates;
  originalCoverage!: StationCoverageResult;

  constructor(data?: IStationCoverageSetup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.dateRange = new DateRange();
      this.returnLocationInfoByID = {};
      this.originalAggregates = new StationCoverageAggregates();
      this.originalCoverage = new StationCoverageResult();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dateRange = _data['dateRange']
        ? DateRange.fromJS(_data['dateRange'])
        : new DateRange();
      this.totalNrOfDays = _data['totalNrOfDays'];
      if (_data['returnLocationInfoByID']) {
        this.returnLocationInfoByID = {} as any;
        for (let key in _data['returnLocationInfoByID']) {
          if (_data['returnLocationInfoByID'].hasOwnProperty(key))
            (<any>this.returnLocationInfoByID)![key] = _data[
              'returnLocationInfoByID'
            ][key]
              ? ReturnLocationInfo.fromJS(_data['returnLocationInfoByID'][key])
              : new ReturnLocationInfo();
        }
      }
      this.originalAggregates = _data['originalAggregates']
        ? StationCoverageAggregates.fromJS(_data['originalAggregates'])
        : new StationCoverageAggregates();
      this.originalCoverage = _data['originalCoverage']
        ? StationCoverageResult.fromJS(_data['originalCoverage'])
        : new StationCoverageResult();
    }
  }

  static fromJS(data: any): StationCoverageSetup {
    data = typeof data === 'object' ? data : {};
    let result = new StationCoverageSetup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['dateRange'] = this.dateRange
      ? this.dateRange.toJSON()
      : <any>undefined;
    data['totalNrOfDays'] = this.totalNrOfDays;
    if (this.returnLocationInfoByID) {
      data['returnLocationInfoByID'] = {};
      for (let key in this.returnLocationInfoByID) {
        if (this.returnLocationInfoByID.hasOwnProperty(key))
          (<any>data['returnLocationInfoByID'])[key] = this
            .returnLocationInfoByID[key]
            ? this.returnLocationInfoByID[key].toJSON()
            : <any>undefined;
      }
    }
    data['originalAggregates'] = this.originalAggregates
      ? this.originalAggregates.toJSON()
      : <any>undefined;
    data['originalCoverage'] = this.originalCoverage
      ? this.originalCoverage.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IStationCoverageSetup {
  dateRange: DateRange;
  totalNrOfDays: number;
  returnLocationInfoByID: { [key: string]: ReturnLocationInfo };
  originalAggregates: StationCoverageAggregates;
  originalCoverage: StationCoverageResult;
}

export class DateRange implements IDateRange {
  from!: Date;
  excludedTo!: Date;

  constructor(data?: IDateRange) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.from = _data['from']
        ? new Date(_data['from'].toString())
        : <any>undefined;
      this.excludedTo = _data['excludedTo']
        ? new Date(_data['excludedTo'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): DateRange {
    data = typeof data === 'object' ? data : {};
    let result = new DateRange();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['from'] = this.from ? this.from.toISOString() : <any>undefined;
    data['excludedTo'] = this.excludedTo
      ? this.excludedTo.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IDateRange {
  from: Date;
  excludedTo: Date;
}

export class ReturnLocationInfo implements IReturnLocationInfo {
  returnLocationID!: number;
  returnLocationName!: string;
  city!: string;
  latitude!: number;
  longitude!: number;
  displayLabel!: string;
  extraInfoOnHover!: string;
  towingsCount!: number;
  towingsPerDay!: number;
  stations!: ReturnLocationStationInfo[];

  constructor(data?: IReturnLocationInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.stations = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.returnLocationID = _data['returnLocationID'];
      this.returnLocationName = _data['returnLocationName'];
      this.city = _data['city'];
      this.latitude = _data['latitude'];
      this.longitude = _data['longitude'];
      this.displayLabel = _data['displayLabel'];
      this.extraInfoOnHover = _data['extraInfoOnHover'];
      this.towingsCount = _data['towingsCount'];
      this.towingsPerDay = _data['towingsPerDay'];
      if (Array.isArray(_data['stations'])) {
        this.stations = [] as any;
        for (let item of _data['stations'])
          this.stations!.push(ReturnLocationStationInfo.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReturnLocationInfo {
    data = typeof data === 'object' ? data : {};
    let result = new ReturnLocationInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['returnLocationID'] = this.returnLocationID;
    data['returnLocationName'] = this.returnLocationName;
    data['city'] = this.city;
    data['latitude'] = this.latitude;
    data['longitude'] = this.longitude;
    data['displayLabel'] = this.displayLabel;
    data['extraInfoOnHover'] = this.extraInfoOnHover;
    data['towingsCount'] = this.towingsCount;
    data['towingsPerDay'] = this.towingsPerDay;
    if (Array.isArray(this.stations)) {
      data['stations'] = [];
      for (let item of this.stations) data['stations'].push(item.toJSON());
    }
    return data;
  }
}

export interface IReturnLocationInfo {
  returnLocationID: number;
  returnLocationName: string;
  city: string;
  latitude: number;
  longitude: number;
  displayLabel: string;
  extraInfoOnHover: string;
  towingsCount: number;
  towingsPerDay: number;
  stations: ReturnLocationStationInfo[];
}

export class ReturnLocationStationInfo implements IReturnLocationStationInfo {
  stationID!: number;
  stationName!: string;
  stationCity!: string;
  towingsCount!: number;
  towingsPerDay!: number;

  constructor(data?: IReturnLocationStationInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.stationID = _data['stationID'];
      this.stationName = _data['stationName'];
      this.stationCity = _data['stationCity'];
      this.towingsCount = _data['towingsCount'];
      this.towingsPerDay = _data['towingsPerDay'];
    }
  }

  static fromJS(data: any): ReturnLocationStationInfo {
    data = typeof data === 'object' ? data : {};
    let result = new ReturnLocationStationInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['stationID'] = this.stationID;
    data['stationName'] = this.stationName;
    data['stationCity'] = this.stationCity;
    data['towingsCount'] = this.towingsCount;
    data['towingsPerDay'] = this.towingsPerDay;
    return data;
  }
}

export interface IReturnLocationStationInfo {
  stationID: number;
  stationName: string;
  stationCity: string;
  towingsCount: number;
  towingsPerDay: number;
}

export class StationCoverageAggregates implements IStationCoverageAggregates {
  summationAggregator!: TowingDistanceAggregator;
  activeLocationsByID!: { [key: string]: TowingDistanceAggregator };
  conceptsByID!: { [key: string]: TowingDistanceAggregator };
  conceptGroupsByID!: { [key: string]: TowingDistanceAggregator };
  inactiveLocationsByID!: { [key: string]: InactiveReturnLocationSummation };

  constructor(data?: IStationCoverageAggregates) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.summationAggregator = new TowingDistanceAggregator();
      this.activeLocationsByID = {};
      this.conceptsByID = {};
      this.conceptGroupsByID = {};
      this.inactiveLocationsByID = {};
    }
  }

  init(_data?: any) {
    if (_data) {
      this.summationAggregator = _data['summationAggregator']
        ? TowingDistanceAggregator.fromJS(_data['summationAggregator'])
        : new TowingDistanceAggregator();
      if (_data['activeLocationsByID']) {
        this.activeLocationsByID = {} as any;
        for (let key in _data['activeLocationsByID']) {
          if (_data['activeLocationsByID'].hasOwnProperty(key))
            (<any>this.activeLocationsByID)![key] = _data[
              'activeLocationsByID'
            ][key]
              ? TowingDistanceAggregator.fromJS(
                  _data['activeLocationsByID'][key]
                )
              : new TowingDistanceAggregator();
        }
      }
      if (_data['conceptsByID']) {
        this.conceptsByID = {} as any;
        for (let key in _data['conceptsByID']) {
          if (_data['conceptsByID'].hasOwnProperty(key))
            (<any>this.conceptsByID)![key] = _data['conceptsByID'][key]
              ? TowingDistanceAggregator.fromJS(_data['conceptsByID'][key])
              : new TowingDistanceAggregator();
        }
      }
      if (_data['conceptGroupsByID']) {
        this.conceptGroupsByID = {} as any;
        for (let key in _data['conceptGroupsByID']) {
          if (_data['conceptGroupsByID'].hasOwnProperty(key))
            (<any>this.conceptGroupsByID)![key] = _data['conceptGroupsByID'][
              key
            ]
              ? TowingDistanceAggregator.fromJS(_data['conceptGroupsByID'][key])
              : new TowingDistanceAggregator();
        }
      }
      if (_data['inactiveLocationsByID']) {
        this.inactiveLocationsByID = {} as any;
        for (let key in _data['inactiveLocationsByID']) {
          if (_data['inactiveLocationsByID'].hasOwnProperty(key))
            (<any>this.inactiveLocationsByID)![key] = _data[
              'inactiveLocationsByID'
            ][key]
              ? InactiveReturnLocationSummation.fromJS(
                  _data['inactiveLocationsByID'][key]
                )
              : new InactiveReturnLocationSummation();
        }
      }
    }
  }

  static fromJS(data: any): StationCoverageAggregates {
    data = typeof data === 'object' ? data : {};
    let result = new StationCoverageAggregates();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['summationAggregator'] = this.summationAggregator
      ? this.summationAggregator.toJSON()
      : <any>undefined;
    if (this.activeLocationsByID) {
      data['activeLocationsByID'] = {};
      for (let key in this.activeLocationsByID) {
        if (this.activeLocationsByID.hasOwnProperty(key))
          (<any>data['activeLocationsByID'])[key] = this.activeLocationsByID[
            key
          ]
            ? this.activeLocationsByID[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.conceptsByID) {
      data['conceptsByID'] = {};
      for (let key in this.conceptsByID) {
        if (this.conceptsByID.hasOwnProperty(key))
          (<any>data['conceptsByID'])[key] = this.conceptsByID[key]
            ? this.conceptsByID[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.conceptGroupsByID) {
      data['conceptGroupsByID'] = {};
      for (let key in this.conceptGroupsByID) {
        if (this.conceptGroupsByID.hasOwnProperty(key))
          (<any>data['conceptGroupsByID'])[key] = this.conceptGroupsByID[key]
            ? this.conceptGroupsByID[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.inactiveLocationsByID) {
      data['inactiveLocationsByID'] = {};
      for (let key in this.inactiveLocationsByID) {
        if (this.inactiveLocationsByID.hasOwnProperty(key))
          (<any>data['inactiveLocationsByID'])[key] = this
            .inactiveLocationsByID[key]
            ? this.inactiveLocationsByID[key].toJSON()
            : <any>undefined;
      }
    }
    return data;
  }
}

export interface IStationCoverageAggregates {
  summationAggregator: TowingDistanceAggregator;
  activeLocationsByID: { [key: string]: TowingDistanceAggregator };
  conceptsByID: { [key: string]: TowingDistanceAggregator };
  conceptGroupsByID: { [key: string]: TowingDistanceAggregator };
  inactiveLocationsByID: { [key: string]: InactiveReturnLocationSummation };
}

export class TowingDistanceAggregator implements ITowingDistanceAggregator {
  constructor(data?: ITowingDistanceAggregator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): TowingDistanceAggregator {
    data = typeof data === 'object' ? data : {};
    let result = new TowingDistanceAggregator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    return data;
  }
}

export interface ITowingDistanceAggregator {}

export class InactiveReturnLocationSummation
  implements IInactiveReturnLocationSummation {
  returnLocationID!: number;
  inactivationAggregator!: TowingDistanceAggregator;
  replacementLocationsByID!: { [key: string]: ReplacementReturnLocation };

  constructor(data?: IInactiveReturnLocationSummation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.inactivationAggregator = new TowingDistanceAggregator();
      this.replacementLocationsByID = {};
    }
  }

  init(_data?: any) {
    if (_data) {
      this.returnLocationID = _data['returnLocationID'];
      this.inactivationAggregator = _data['inactivationAggregator']
        ? TowingDistanceAggregator.fromJS(_data['inactivationAggregator'])
        : new TowingDistanceAggregator();
      if (_data['replacementLocationsByID']) {
        this.replacementLocationsByID = {} as any;
        for (let key in _data['replacementLocationsByID']) {
          if (_data['replacementLocationsByID'].hasOwnProperty(key))
            (<any>this.replacementLocationsByID)![key] = _data[
              'replacementLocationsByID'
            ][key]
              ? ReplacementReturnLocation.fromJS(
                  _data['replacementLocationsByID'][key]
                )
              : new ReplacementReturnLocation();
        }
      }
    }
  }

  static fromJS(data: any): InactiveReturnLocationSummation {
    data = typeof data === 'object' ? data : {};
    let result = new InactiveReturnLocationSummation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['returnLocationID'] = this.returnLocationID;
    data['inactivationAggregator'] = this.inactivationAggregator
      ? this.inactivationAggregator.toJSON()
      : <any>undefined;
    if (this.replacementLocationsByID) {
      data['replacementLocationsByID'] = {};
      for (let key in this.replacementLocationsByID) {
        if (this.replacementLocationsByID.hasOwnProperty(key))
          (<any>data['replacementLocationsByID'])[key] = this
            .replacementLocationsByID[key]
            ? this.replacementLocationsByID[key].toJSON()
            : <any>undefined;
      }
    }
    return data;
  }
}

export interface IInactiveReturnLocationSummation {
  returnLocationID: number;
  inactivationAggregator: TowingDistanceAggregator;
  replacementLocationsByID: { [key: string]: ReplacementReturnLocation };
}

export class ReplacementReturnLocation implements IReplacementReturnLocation {
  toReturnLocationID!: number;
  reassignedTowingsCount!: number;

  constructor(data?: IReplacementReturnLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.toReturnLocationID = _data['toReturnLocationID'];
      this.reassignedTowingsCount = _data['reassignedTowingsCount'];
    }
  }

  static fromJS(data: any): ReplacementReturnLocation {
    data = typeof data === 'object' ? data : {};
    let result = new ReplacementReturnLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['toReturnLocationID'] = this.toReturnLocationID;
    data['reassignedTowingsCount'] = this.reassignedTowingsCount;
    return data;
  }
}

export interface IReplacementReturnLocation {
  toReturnLocationID: number;
  reassignedTowingsCount: number;
}

export class StationCoverageResult implements IStationCoverageResult {
  coverageName!: string;
  generalInfo!: string;
  overviewBoxes!: CompiledStatsLines[];
  returnLocations!: ReturnLocationPresentation[];
  conceptInfo!: ConceptInfo;

  constructor(data?: IStationCoverageResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.overviewBoxes = [];
      this.returnLocations = [];
      this.conceptInfo = new ConceptInfo();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.coverageName = _data['coverageName'];
      this.generalInfo = _data['generalInfo'];
      if (Array.isArray(_data['overviewBoxes'])) {
        this.overviewBoxes = [] as any;
        for (let item of _data['overviewBoxes'])
          this.overviewBoxes!.push(CompiledStatsLines.fromJS(item));
      }
      if (Array.isArray(_data['returnLocations'])) {
        this.returnLocations = [] as any;
        for (let item of _data['returnLocations'])
          this.returnLocations!.push(ReturnLocationPresentation.fromJS(item));
      }
      this.conceptInfo = _data['conceptInfo']
        ? ConceptInfo.fromJS(_data['conceptInfo'])
        : new ConceptInfo();
    }
  }

  static fromJS(data: any): StationCoverageResult {
    data = typeof data === 'object' ? data : {};
    let result = new StationCoverageResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['coverageName'] = this.coverageName;
    data['generalInfo'] = this.generalInfo;
    if (Array.isArray(this.overviewBoxes)) {
      data['overviewBoxes'] = [];
      for (let item of this.overviewBoxes)
        data['overviewBoxes'].push(item.toJSON());
    }
    if (Array.isArray(this.returnLocations)) {
      data['returnLocations'] = [];
      for (let item of this.returnLocations)
        data['returnLocations'].push(item.toJSON());
    }
    data['conceptInfo'] = this.conceptInfo
      ? this.conceptInfo.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IStationCoverageResult {
  coverageName: string;
  generalInfo: string;
  overviewBoxes: CompiledStatsLines[];
  returnLocations: ReturnLocationPresentation[];
  conceptInfo: ConceptInfo;
}

export class CompiledStatsLines implements ICompiledStatsLines {
  header!: string;
  lines!: string[];

  constructor(data?: ICompiledStatsLines) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.lines = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.header = _data['header'];
      if (Array.isArray(_data['lines'])) {
        this.lines = [] as any;
        for (let item of _data['lines']) this.lines!.push(item);
      }
    }
  }

  static fromJS(data: any): CompiledStatsLines {
    data = typeof data === 'object' ? data : {};
    let result = new CompiledStatsLines();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['header'] = this.header;
    if (Array.isArray(this.lines)) {
      data['lines'] = [];
      for (let item of this.lines) data['lines'].push(item);
    }
    return data;
  }
}

export interface ICompiledStatsLines {
  header: string;
  lines: string[];
}

export class ReturnLocationPresentation implements IReturnLocationPresentation {
  returnLocationID!: number;
  isActive!: boolean;
  header!: string;
  extraInfoOnHover!: string;
  lines!: string[];

  constructor(data?: IReturnLocationPresentation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.lines = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.returnLocationID = _data['returnLocationID'];
      this.isActive = _data['isActive'];
      this.header = _data['header'];
      this.extraInfoOnHover = _data['extraInfoOnHover'];
      if (Array.isArray(_data['lines'])) {
        this.lines = [] as any;
        for (let item of _data['lines']) this.lines!.push(item);
      }
    }
  }

  static fromJS(data: any): ReturnLocationPresentation {
    data = typeof data === 'object' ? data : {};
    let result = new ReturnLocationPresentation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['returnLocationID'] = this.returnLocationID;
    data['isActive'] = this.isActive;
    data['header'] = this.header;
    data['extraInfoOnHover'] = this.extraInfoOnHover;
    if (Array.isArray(this.lines)) {
      data['lines'] = [];
      for (let item of this.lines) data['lines'].push(item);
    }
    return data;
  }
}

export interface IReturnLocationPresentation {
  returnLocationID: number;
  isActive: boolean;
  header: string;
  extraInfoOnHover: string;
  lines: string[];
}

export class ConceptInfo implements IConceptInfo {
  generalInfo!: string;
  headers!: DisplayHeader[];
  conceptGroupRows!: ConceptGroupPresentation[];

  constructor(data?: IConceptInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.headers = [];
      this.conceptGroupRows = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.generalInfo = _data['generalInfo'];
      if (Array.isArray(_data['headers'])) {
        this.headers = [] as any;
        for (let item of _data['headers'])
          this.headers!.push(DisplayHeader.fromJS(item));
      }
      if (Array.isArray(_data['conceptGroupRows'])) {
        this.conceptGroupRows = [] as any;
        for (let item of _data['conceptGroupRows'])
          this.conceptGroupRows!.push(ConceptGroupPresentation.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ConceptInfo {
    data = typeof data === 'object' ? data : {};
    let result = new ConceptInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['generalInfo'] = this.generalInfo;
    if (Array.isArray(this.headers)) {
      data['headers'] = [];
      for (let item of this.headers) data['headers'].push(item.toJSON());
    }
    if (Array.isArray(this.conceptGroupRows)) {
      data['conceptGroupRows'] = [];
      for (let item of this.conceptGroupRows)
        data['conceptGroupRows'].push(item.toJSON());
    }
    return data;
  }
}

export interface IConceptInfo {
  generalInfo: string;
  headers: DisplayHeader[];
  conceptGroupRows: ConceptGroupPresentation[];
}

export class DisplayHeader implements IDisplayHeader {
  columnType!: DisplayColumnType;
  header!: string;

  constructor(data?: IDisplayHeader) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.columnType = _data['columnType'];
      this.header = _data['header'];
    }
  }

  static fromJS(data: any): DisplayHeader {
    data = typeof data === 'object' ? data : {};
    let result = new DisplayHeader();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['columnType'] = this.columnType;
    data['header'] = this.header;
    return data;
  }
}

export interface IDisplayHeader {
  columnType: DisplayColumnType;
  header: string;
}

export enum DisplayColumnType {
  String = 1,
  Decimal = 2,
}

export class ConceptGroupPresentation implements IConceptGroupPresentation {
  groupID!: number;
  cells!: DisplayCell[];
  conceptsInGroup!: ConceptPresentation[];

  constructor(data?: IConceptGroupPresentation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.cells = [];
      this.conceptsInGroup = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.groupID = _data['groupID'];
      if (Array.isArray(_data['cells'])) {
        this.cells = [] as any;
        for (let item of _data['cells'])
          this.cells!.push(DisplayCell.fromJS(item));
      }
      if (Array.isArray(_data['conceptsInGroup'])) {
        this.conceptsInGroup = [] as any;
        for (let item of _data['conceptsInGroup'])
          this.conceptsInGroup!.push(ConceptPresentation.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ConceptGroupPresentation {
    data = typeof data === 'object' ? data : {};
    let result = new ConceptGroupPresentation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['groupID'] = this.groupID;
    if (Array.isArray(this.cells)) {
      data['cells'] = [];
      for (let item of this.cells) data['cells'].push(item.toJSON());
    }
    if (Array.isArray(this.conceptsInGroup)) {
      data['conceptsInGroup'] = [];
      for (let item of this.conceptsInGroup)
        data['conceptsInGroup'].push(item.toJSON());
    }
    return data;
  }
}

export interface IConceptGroupPresentation {
  groupID: number;
  cells: DisplayCell[];
  conceptsInGroup: ConceptPresentation[];
}

export class DisplayCell implements IDisplayCell {
  decimalValue!: number;
  displayValue!: string;

  constructor(data?: IDisplayCell) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.decimalValue = _data['decimalValue'];
      this.displayValue = _data['displayValue'];
    }
  }

  static fromJS(data: any): DisplayCell {
    data = typeof data === 'object' ? data : {};
    let result = new DisplayCell();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['decimalValue'] = this.decimalValue;
    data['displayValue'] = this.displayValue;
    return data;
  }
}

export interface IDisplayCell {
  decimalValue: number;
  displayValue: string;
}

export class ConceptPresentation implements IConceptPresentation {
  conceptID!: number;
  cells!: DisplayCell[];

  constructor(data?: IConceptPresentation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.cells = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conceptID = _data['conceptID'];
      if (Array.isArray(_data['cells'])) {
        this.cells = [] as any;
        for (let item of _data['cells'])
          this.cells!.push(DisplayCell.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ConceptPresentation {
    data = typeof data === 'object' ? data : {};
    let result = new ConceptPresentation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conceptID'] = this.conceptID;
    if (Array.isArray(this.cells)) {
      data['cells'] = [];
      for (let item of this.cells) data['cells'].push(item.toJSON());
    }
    return data;
  }
}

export interface IConceptPresentation {
  conceptID: number;
  cells: DisplayCell[];
}

export class StationCoverageSetModel implements IStationCoverageSetModel {
  id!: number;
  name!: string;
  overviewInfo!: string;
  inactivatedReturnLocationIDs!: number[];

  constructor(data?: IStationCoverageSetModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.inactivatedReturnLocationIDs = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.overviewInfo = _data['overviewInfo'];
      if (Array.isArray(_data['inactivatedReturnLocationIDs'])) {
        this.inactivatedReturnLocationIDs = [] as any;
        for (let item of _data['inactivatedReturnLocationIDs'])
          this.inactivatedReturnLocationIDs!.push(item);
      }
    }
  }

  static fromJS(data: any): StationCoverageSetModel {
    data = typeof data === 'object' ? data : {};
    let result = new StationCoverageSetModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['overviewInfo'] = this.overviewInfo;
    if (Array.isArray(this.inactivatedReturnLocationIDs)) {
      data['inactivatedReturnLocationIDs'] = [];
      for (let item of this.inactivatedReturnLocationIDs)
        data['inactivatedReturnLocationIDs'].push(item);
    }
    return data;
  }
}

export interface IStationCoverageSetModel {
  id: number;
  name: string;
  overviewInfo: string;
  inactivatedReturnLocationIDs: number[];
}

export class SaveStationCoverageSetResult
  implements ISaveStationCoverageSetResult {
  result!: StationCoverageResult;
  updatedSetModel!: StationCoverageSetModel;

  constructor(data?: ISaveStationCoverageSetResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.result = new StationCoverageResult();
      this.updatedSetModel = new StationCoverageSetModel();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data['result']
        ? StationCoverageResult.fromJS(_data['result'])
        : new StationCoverageResult();
      this.updatedSetModel = _data['updatedSetModel']
        ? StationCoverageSetModel.fromJS(_data['updatedSetModel'])
        : new StationCoverageSetModel();
    }
  }

  static fromJS(data: any): SaveStationCoverageSetResult {
    data = typeof data === 'object' ? data : {};
    let result = new SaveStationCoverageSetResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['result'] = this.result ? this.result.toJSON() : <any>undefined;
    data['updatedSetModel'] = this.updatedSetModel
      ? this.updatedSetModel.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface ISaveStationCoverageSetResult {
  result: StationCoverageResult;
  updatedSetModel: StationCoverageSetModel;
}

export class StatsSetModel implements IStatsSetModel {
  excelDownloadGuid!: string;
  columnSettings!: ColumnSettingsModel[];
  rows!: StatsCellModel[][];
  summaryRow!: StatsCellModel[];

  constructor(data?: IStatsSetModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.columnSettings = [];
      this.rows = [];
      this.summaryRow = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.excelDownloadGuid = _data['excelDownloadGuid'];
      if (Array.isArray(_data['columnSettings'])) {
        this.columnSettings = [] as any;
        for (let item of _data['columnSettings'])
          this.columnSettings!.push(ColumnSettingsModel.fromJS(item));
      }
      if (Array.isArray(_data['rows'])) {
        this.rows = [] as any;
        for (let item of _data['rows']) this.rows!.push(item);
      }
      if (Array.isArray(_data['summaryRow'])) {
        this.summaryRow = [] as any;
        for (let item of _data['summaryRow'])
          this.summaryRow!.push(StatsCellModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StatsSetModel {
    data = typeof data === 'object' ? data : {};
    let result = new StatsSetModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['excelDownloadGuid'] = this.excelDownloadGuid;
    if (Array.isArray(this.columnSettings)) {
      data['columnSettings'] = [];
      for (let item of this.columnSettings)
        data['columnSettings'].push(item.toJSON());
    }
    if (Array.isArray(this.rows)) {
      data['rows'] = [];
      for (let item of this.rows) data['rows'].push(item);
    }
    if (Array.isArray(this.summaryRow)) {
      data['summaryRow'] = [];
      for (let item of this.summaryRow) data['summaryRow'].push(item.toJSON());
    }
    return data;
  }
}

export interface IStatsSetModel {
  excelDownloadGuid: string;
  columnSettings: ColumnSettingsModel[];
  rows: StatsCellModel[][];
  summaryRow: StatsCellModel[];
}

export class ColumnSettingsModel implements IColumnSettingsModel {
  header!: string;
  subHeader!: string;
  paramSelection!: ParamSelection;
  paramCalculationType!: ParamCalculationType;

  constructor(data?: IColumnSettingsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.header = _data['header'];
      this.subHeader = _data['subHeader'];
      this.paramSelection = _data['paramSelection'];
      this.paramCalculationType = _data['paramCalculationType'];
    }
  }

  static fromJS(data: any): ColumnSettingsModel {
    data = typeof data === 'object' ? data : {};
    let result = new ColumnSettingsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['header'] = this.header;
    data['subHeader'] = this.subHeader;
    data['paramSelection'] = this.paramSelection;
    data['paramCalculationType'] = this.paramCalculationType;
    return data;
  }
}

export interface IColumnSettingsModel {
  header: string;
  subHeader: string;
  paramSelection: ParamSelection;
  paramCalculationType: ParamCalculationType;
}

export enum ParamSelection {
  RowCount = 1,
  RowName = 2,
  IsInvoiceCompleted = 100,
  IsRegisteredAfterTowing = 101,
  IsPreOrder = 102,
  IsCompletedOnIncidentLocation = 103,
  PictureCount_4Plus = 104,
  AreAllTimestampsValid = 106,
  TotalDistanceInKm = 107,
  SurchargedDistanceInKm = 108,
  TS_FleetManagerStart_TowingAssigned = 150,
  TS_FleetManagerStart_ArrivedAtIncident = 151,
  TS_TowingAssigned_ArrivedAtIncident = 152,
  TS_TowingAssigned_Completed = 153,
  TS_ArrivedAtIncident_VehicleDelivered = 154,
  PayedAmount_EndCustomer = 200,
  PayedAmount_Primary = 201,
  PayedAmount_Other = 202,
  Price_Unit = 300,
  Price_HourlyRate = 301,
  Price_Tma = 302,
  Price_DriveDistance = 303,
  Price_Other = 304,
  PriceSubset_Deductible = 350,
  TotalSalesPrice = 399,
  RadioNumber = 500,
}

export enum ParamCalculationType {
  Average = 1,
  None = 2,
  PercentageOfTotalPrice = 100,
  PercentageOfAllGroups = 101,
  PercentageOfRowCount = 102,
  Total_And_PercentageOfTotalPrice = 200,
  Total_And_PercentageOfAllGroups = 201,
  Total_And_PercentageOfRowCount = 202,
  Total = 203,
}

export class StatsCellModel implements IStatsCellModel {
  displayValue!: string;
  calculatedValue!: number;
  rawAggregateValue!: number;

  constructor(data?: IStatsCellModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayValue = _data['displayValue'];
      this.calculatedValue = _data['calculatedValue'];
      this.rawAggregateValue = _data['rawAggregateValue'];
    }
  }

  static fromJS(data: any): StatsCellModel {
    data = typeof data === 'object' ? data : {};
    let result = new StatsCellModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayValue'] = this.displayValue;
    data['calculatedValue'] = this.calculatedValue;
    data['rawAggregateValue'] = this.rawAggregateValue;
    return data;
  }
}

export interface IStatsCellModel {
  displayValue: string;
  calculatedValue: number;
  rawAggregateValue: number;
}

export class StatsRequestModel implements IStatsRequestModel {
  fromUtc!: Date;
  toUtc!: Date;
  filtersByGroups!: FilterByGroupsModel[];
  filtersBySingleIDs!: FilterBySingleIDsModel[];
  groupByMonth!: boolean;
  groupByIdType?: IdType | undefined;
  groupByGroupSetID?: number | undefined;
  includedParams!: StatsRequestParamsModel[];

  constructor(data?: IStatsRequestModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.filtersByGroups = [];
      this.filtersBySingleIDs = [];
      this.includedParams = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fromUtc = _data['fromUtc']
        ? new Date(_data['fromUtc'].toString())
        : <any>undefined;
      this.toUtc = _data['toUtc']
        ? new Date(_data['toUtc'].toString())
        : <any>undefined;
      if (Array.isArray(_data['filtersByGroups'])) {
        this.filtersByGroups = [] as any;
        for (let item of _data['filtersByGroups'])
          this.filtersByGroups!.push(FilterByGroupsModel.fromJS(item));
      }
      if (Array.isArray(_data['filtersBySingleIDs'])) {
        this.filtersBySingleIDs = [] as any;
        for (let item of _data['filtersBySingleIDs'])
          this.filtersBySingleIDs!.push(FilterBySingleIDsModel.fromJS(item));
      }
      this.groupByMonth = _data['groupByMonth'];
      this.groupByIdType = _data['groupByIdType'];
      this.groupByGroupSetID = _data['groupByGroupSetID'];
      if (Array.isArray(_data['includedParams'])) {
        this.includedParams = [] as any;
        for (let item of _data['includedParams'])
          this.includedParams!.push(StatsRequestParamsModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StatsRequestModel {
    data = typeof data === 'object' ? data : {};
    let result = new StatsRequestModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fromUtc'] = this.fromUtc
      ? this.fromUtc.toISOString()
      : <any>undefined;
    data['toUtc'] = this.toUtc ? this.toUtc.toISOString() : <any>undefined;
    if (Array.isArray(this.filtersByGroups)) {
      data['filtersByGroups'] = [];
      for (let item of this.filtersByGroups)
        data['filtersByGroups'].push(item.toJSON());
    }
    if (Array.isArray(this.filtersBySingleIDs)) {
      data['filtersBySingleIDs'] = [];
      for (let item of this.filtersBySingleIDs)
        data['filtersBySingleIDs'].push(item.toJSON());
    }
    data['groupByMonth'] = this.groupByMonth;
    data['groupByIdType'] = this.groupByIdType;
    data['groupByGroupSetID'] = this.groupByGroupSetID;
    if (Array.isArray(this.includedParams)) {
      data['includedParams'] = [];
      for (let item of this.includedParams)
        data['includedParams'].push(item.toJSON());
    }
    return data;
  }
}

export interface IStatsRequestModel {
  fromUtc: Date;
  toUtc: Date;
  filtersByGroups: FilterByGroupsModel[];
  filtersBySingleIDs: FilterBySingleIDsModel[];
  groupByMonth: boolean;
  groupByIdType?: IdType | undefined;
  groupByGroupSetID?: number | undefined;
  includedParams: StatsRequestParamsModel[];
}

export class FilterByGroupsModel implements IFilterByGroupsModel {
  idType!: IdType;
  groupSetID!: number;
  includedGroupIDs!: number[];

  constructor(data?: IFilterByGroupsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.includedGroupIDs = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.idType = _data['idType'];
      this.groupSetID = _data['groupSetID'];
      if (Array.isArray(_data['includedGroupIDs'])) {
        this.includedGroupIDs = [] as any;
        for (let item of _data['includedGroupIDs'])
          this.includedGroupIDs!.push(item);
      }
    }
  }

  static fromJS(data: any): FilterByGroupsModel {
    data = typeof data === 'object' ? data : {};
    let result = new FilterByGroupsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['idType'] = this.idType;
    data['groupSetID'] = this.groupSetID;
    if (Array.isArray(this.includedGroupIDs)) {
      data['includedGroupIDs'] = [];
      for (let item of this.includedGroupIDs)
        data['includedGroupIDs'].push(item);
    }
    return data;
  }
}

export interface IFilterByGroupsModel {
  idType: IdType;
  groupSetID: number;
  includedGroupIDs: number[];
}

export enum IdType {
  StationID = 1,
  ConceptID = 2,
  AssignmentOriginID = 3,
  InsuranceCompanyID = 4,
  AssistancePackageID = 5,
  IncidentTypeID = 6,
  HelpTypeID = 7,
  VehicleTypeID = 8,
  CarBrandID = 9,
  DriverEmployeeID = 10,
  RepairShopID = 11,
  TimeCategoryID = 12,
  ObjectGroupID = 13,
  PayingCustomerID = 14,
  ReturnLocationID = 15,
  SecondaryCustomerID = 16,
  SmsStatusID = 201,
  RadioNumber = 300,
  AxCustomerNumberID = 401,
}

export class FilterBySingleIDsModel implements IFilterBySingleIDsModel {
  idType!: IdType;
  includedIDs!: number[];

  constructor(data?: IFilterBySingleIDsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.includedIDs = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.idType = _data['idType'];
      if (Array.isArray(_data['includedIDs'])) {
        this.includedIDs = [] as any;
        for (let item of _data['includedIDs']) this.includedIDs!.push(item);
      }
    }
  }

  static fromJS(data: any): FilterBySingleIDsModel {
    data = typeof data === 'object' ? data : {};
    let result = new FilterBySingleIDsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['idType'] = this.idType;
    if (Array.isArray(this.includedIDs)) {
      data['includedIDs'] = [];
      for (let item of this.includedIDs) data['includedIDs'].push(item);
    }
    return data;
  }
}

export interface IFilterBySingleIDsModel {
  idType: IdType;
  includedIDs: number[];
}

export class StatsRequestParamsModel implements IStatsRequestParamsModel {
  paramSelection!: ParamSelection;
  paramCalculationType!: ParamCalculationType;

  constructor(data?: IStatsRequestParamsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paramSelection = _data['paramSelection'];
      this.paramCalculationType = _data['paramCalculationType'];
    }
  }

  static fromJS(data: any): StatsRequestParamsModel {
    data = typeof data === 'object' ? data : {};
    let result = new StatsRequestParamsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['paramSelection'] = this.paramSelection;
    data['paramCalculationType'] = this.paramCalculationType;
    return data;
  }
}

export interface IStatsRequestParamsModel {
  paramSelection: ParamSelection;
  paramCalculationType: ParamCalculationType;
}

export class YearlyReportsModel implements IYearlyReportsModel {
  year!: number;
  conceptGroupedSet!: StatsSetComparisonModel;
  monthGroupedSet!: StatsSetComparisonModel;

  constructor(data?: IYearlyReportsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.conceptGroupedSet = new StatsSetComparisonModel();
      this.monthGroupedSet = new StatsSetComparisonModel();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data['year'];
      this.conceptGroupedSet = _data['conceptGroupedSet']
        ? StatsSetComparisonModel.fromJS(_data['conceptGroupedSet'])
        : new StatsSetComparisonModel();
      this.monthGroupedSet = _data['monthGroupedSet']
        ? StatsSetComparisonModel.fromJS(_data['monthGroupedSet'])
        : new StatsSetComparisonModel();
    }
  }

  static fromJS(data: any): YearlyReportsModel {
    data = typeof data === 'object' ? data : {};
    let result = new YearlyReportsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['year'] = this.year;
    data['conceptGroupedSet'] = this.conceptGroupedSet
      ? this.conceptGroupedSet.toJSON()
      : <any>undefined;
    data['monthGroupedSet'] = this.monthGroupedSet
      ? this.monthGroupedSet.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IYearlyReportsModel {
  year: number;
  conceptGroupedSet: StatsSetComparisonModel;
  monthGroupedSet: StatsSetComparisonModel;
}

export class StatsSetComparisonModel implements IStatsSetComparisonModel {
  mainStats!: StatsSetModel;
  prevYearStats!: StatsSetModel;

  constructor(data?: IStatsSetComparisonModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.mainStats = new StatsSetModel();
      this.prevYearStats = new StatsSetModel();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.mainStats = _data['mainStats']
        ? StatsSetModel.fromJS(_data['mainStats'])
        : new StatsSetModel();
      this.prevYearStats = _data['prevYearStats']
        ? StatsSetModel.fromJS(_data['prevYearStats'])
        : new StatsSetModel();
    }
  }

  static fromJS(data: any): StatsSetComparisonModel {
    data = typeof data === 'object' ? data : {};
    let result = new StatsSetComparisonModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['mainStats'] = this.mainStats
      ? this.mainStats.toJSON()
      : <any>undefined;
    data['prevYearStats'] = this.prevYearStats
      ? this.prevYearStats.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IStatsSetComparisonModel {
  mainStats: StatsSetModel;
  prevYearStats: StatsSetModel;
}

export class QuarterlyReportsModel implements IQuarterlyReportsModel {
  quarter!: QuarterModel;
  conceptGroupedSet!: StatsSetComparisonModel;
  monthGroupedSet!: StatsSetComparisonModel;

  constructor(data?: IQuarterlyReportsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.quarter = new QuarterModel();
      this.conceptGroupedSet = new StatsSetComparisonModel();
      this.monthGroupedSet = new StatsSetComparisonModel();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quarter = _data['quarter']
        ? QuarterModel.fromJS(_data['quarter'])
        : new QuarterModel();
      this.conceptGroupedSet = _data['conceptGroupedSet']
        ? StatsSetComparisonModel.fromJS(_data['conceptGroupedSet'])
        : new StatsSetComparisonModel();
      this.monthGroupedSet = _data['monthGroupedSet']
        ? StatsSetComparisonModel.fromJS(_data['monthGroupedSet'])
        : new StatsSetComparisonModel();
    }
  }

  static fromJS(data: any): QuarterlyReportsModel {
    data = typeof data === 'object' ? data : {};
    let result = new QuarterlyReportsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['quarter'] = this.quarter ? this.quarter.toJSON() : <any>undefined;
    data['conceptGroupedSet'] = this.conceptGroupedSet
      ? this.conceptGroupedSet.toJSON()
      : <any>undefined;
    data['monthGroupedSet'] = this.monthGroupedSet
      ? this.monthGroupedSet.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IQuarterlyReportsModel {
  quarter: QuarterModel;
  conceptGroupedSet: StatsSetComparisonModel;
  monthGroupedSet: StatsSetComparisonModel;
}

export class QuarterModel implements IQuarterModel {
  year!: number;
  quarter!: number;

  constructor(data?: IQuarterModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data['year'];
      this.quarter = _data['quarter'];
    }
  }

  static fromJS(data: any): QuarterModel {
    data = typeof data === 'object' ? data : {};
    let result = new QuarterModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['year'] = this.year;
    data['quarter'] = this.quarter;
    return data;
  }
}

export interface IQuarterModel {
  year: number;
  quarter: number;
}

export class InvoiceStatsRequestModel implements IInvoiceStatsRequestModel {
  fromUtc!: Date;
  toUtc!: Date;
  includedGroupIDs!: number[];
  groupByMonth!: boolean;
  groupByPrimaryCustomerGroupSet!: boolean;
  groupByPrimaryCustomerID!: boolean;

  constructor(data?: IInvoiceStatsRequestModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.includedGroupIDs = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fromUtc = _data['fromUtc']
        ? new Date(_data['fromUtc'].toString())
        : <any>undefined;
      this.toUtc = _data['toUtc']
        ? new Date(_data['toUtc'].toString())
        : <any>undefined;
      if (Array.isArray(_data['includedGroupIDs'])) {
        this.includedGroupIDs = [] as any;
        for (let item of _data['includedGroupIDs'])
          this.includedGroupIDs!.push(item);
      }
      this.groupByMonth = _data['groupByMonth'];
      this.groupByPrimaryCustomerGroupSet =
        _data['groupByPrimaryCustomerGroupSet'];
      this.groupByPrimaryCustomerID = _data['groupByPrimaryCustomerID'];
    }
  }

  static fromJS(data: any): InvoiceStatsRequestModel {
    data = typeof data === 'object' ? data : {};
    let result = new InvoiceStatsRequestModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fromUtc'] = this.fromUtc
      ? this.fromUtc.toISOString()
      : <any>undefined;
    data['toUtc'] = this.toUtc ? this.toUtc.toISOString() : <any>undefined;
    if (Array.isArray(this.includedGroupIDs)) {
      data['includedGroupIDs'] = [];
      for (let item of this.includedGroupIDs)
        data['includedGroupIDs'].push(item);
    }
    data['groupByMonth'] = this.groupByMonth;
    data[
      'groupByPrimaryCustomerGroupSet'
    ] = this.groupByPrimaryCustomerGroupSet;
    data['groupByPrimaryCustomerID'] = this.groupByPrimaryCustomerID;
    return data;
  }
}

export interface IInvoiceStatsRequestModel {
  fromUtc: Date;
  toUtc: Date;
  includedGroupIDs: number[];
  groupByMonth: boolean;
  groupByPrimaryCustomerGroupSet: boolean;
  groupByPrimaryCustomerID: boolean;
}

export class BankSignBaseResponse implements IBankSignBaseResponse {
  statusMessage?: string | undefined;
  status!: LoginStatus;

  constructor(data?: IBankSignBaseResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.statusMessage = _data['statusMessage'];
      this.status = _data['status'];
    }
  }

  static fromJS(data: any): BankSignBaseResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BankSignBaseResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['statusMessage'] = this.statusMessage;
    data['status'] = this.status;
    return data;
  }
}

export interface IBankSignBaseResponse {
  statusMessage?: string | undefined;
  status: LoginStatus;
}

export class BankSignInitiationResponse
  extends BankSignBaseResponse
  implements IBankSignInitiationResponse {
  sessionId?: string | undefined;
  autoStartToken?: string | undefined;
  qrImageUrl?: string | undefined;

  constructor(data?: IBankSignInitiationResponse) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.sessionId = _data['sessionId'];
      this.autoStartToken = _data['autoStartToken'];
      this.qrImageUrl = _data['qrImageUrl'];
    }
  }

  static fromJS(data: any): BankSignInitiationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BankSignInitiationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['sessionId'] = this.sessionId;
    data['autoStartToken'] = this.autoStartToken;
    data['qrImageUrl'] = this.qrImageUrl;
    super.toJSON(data);
    return data;
  }
}

export interface IBankSignInitiationResponse extends IBankSignBaseResponse {
  sessionId?: string | undefined;
  autoStartToken?: string | undefined;
  qrImageUrl?: string | undefined;
}

export enum LoginStatus {
  Error = 0,
  InitiationSuccess = 1,
  Pending = 2,
  Complete = 3,
}

export class BankSignCollectResponse
  extends BankSignBaseResponse
  implements IBankSignCollectResponse {
  jwtToken?: string | undefined;
  jwtRefreshToken?: string | undefined;
  user?: WebUser | undefined;

  constructor(data?: IBankSignCollectResponse) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.jwtToken = _data['jwtToken'];
      this.jwtRefreshToken = _data['jwtRefreshToken'];
      this.user = _data['user']
        ? WebUser.fromJS(_data['user'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): BankSignCollectResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BankSignCollectResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['jwtToken'] = this.jwtToken;
    data['jwtRefreshToken'] = this.jwtRefreshToken;
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    super.toJSON(data);
    return data;
  }
}

export interface IBankSignCollectResponse extends IBankSignBaseResponse {
  jwtToken?: string | undefined;
  jwtRefreshToken?: string | undefined;
  user?: WebUser | undefined;
}

export class WebUser implements IWebUser {
  id!: number;
  userName!: string;
  fullName!: string;
  email!: string;
  roles!: number[];
  stationIds!: number[];
  deactivated!: boolean;

  constructor(data?: IWebUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.roles = [];
      this.stationIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(item);
      }
      if (Array.isArray(_data['stationIds'])) {
        this.stationIds = [] as any;
        for (let item of _data['stationIds']) this.stationIds!.push(item);
      }
      this.deactivated = _data['deactivated'];
    }
  }

  static fromJS(data: any): WebUser {
    data = typeof data === 'object' ? data : {};
    let result = new WebUser();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item);
    }
    if (Array.isArray(this.stationIds)) {
      data['stationIds'] = [];
      for (let item of this.stationIds) data['stationIds'].push(item);
    }
    data['deactivated'] = this.deactivated;
    return data;
  }
}

export interface IWebUser {
  id: number;
  userName: string;
  fullName: string;
  email: string;
  roles: number[];
  stationIds: number[];
  deactivated: boolean;
}

export class BankSignRequest implements IBankSignRequest {
  sessionId!: string;
  rememberMe!: boolean;

  constructor(data?: IBankSignRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sessionId = _data['sessionId'];
      this.rememberMe = _data['rememberMe'];
    }
  }

  static fromJS(data: any): BankSignRequest {
    data = typeof data === 'object' ? data : {};
    let result = new BankSignRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['sessionId'] = this.sessionId;
    data['rememberMe'] = this.rememberMe;
    return data;
  }
}

export interface IBankSignRequest {
  sessionId: string;
  rememberMe: boolean;
}

export class RefreshJwtTokenResponse implements IRefreshJwtTokenResponse {
  jwtToken!: string;
  jwtRefreshToken!: string;

  constructor(data?: IRefreshJwtTokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jwtToken = _data['jwtToken'];
      this.jwtRefreshToken = _data['jwtRefreshToken'];
    }
  }

  static fromJS(data: any): RefreshJwtTokenResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RefreshJwtTokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['jwtToken'] = this.jwtToken;
    data['jwtRefreshToken'] = this.jwtRefreshToken;
    return data;
  }
}

export interface IRefreshJwtTokenResponse {
  jwtToken: string;
  jwtRefreshToken: string;
}

export class BasicDataModel implements IBasicDataModel {
  idInfoByIdType!: {
    [key in keyof typeof IdType]?: { [key: string]: IdInfoModel };
  };
  groupSetByType!: { [key in keyof typeof IdType]?: GroupSet[] };
  groupSetsByID!: { [key: string]: GroupSet };
  groupsByID!: { [key: string]: Group };
  axAccountDict!: { [key: string]: number };
  axAccountByCustomerID!: { [key: string]: string };
  employeeMainStationIDs!: { [key: string]: number };
  returnLocationsByID!: { [key: string]: AssistReturnLocation };
  stationReturnLocationsByStationID!: {
    [key: string]: AssistStationReturnLocation[];
  };
  roleNamesByID!: { [key: string]: string };
  stationCityNameByStationID!: { [key: string]: string };
  activeStationIDs!: number[];
  settings!: SettingsModel;
  paramHeaders!: { [key in keyof typeof ParamSelection]?: string };
  calculationDescriptions!: {
    [key in keyof typeof ParamCalculationType]?: string;
  };
  idTypeNames!: { [key in keyof typeof IdType]?: string };

  constructor(data?: IBasicDataModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.idInfoByIdType = {};
      this.groupSetByType = {};
      this.groupSetsByID = {};
      this.groupsByID = {};
      this.axAccountDict = {};
      this.axAccountByCustomerID = {};
      this.employeeMainStationIDs = {};
      this.returnLocationsByID = {};
      this.stationReturnLocationsByStationID = {};
      this.roleNamesByID = {};
      this.stationCityNameByStationID = {};
      this.activeStationIDs = [];
      this.settings = new SettingsModel();
      this.paramHeaders = {};
      this.calculationDescriptions = {};
      this.idTypeNames = {};
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['idInfoByIdType']) {
        this.idInfoByIdType = {} as any;
        for (let key in _data['idInfoByIdType']) {
          if (_data['idInfoByIdType'].hasOwnProperty(key))
            (<any>this.idInfoByIdType)![key] =
              _data['idInfoByIdType'][key] !== undefined
                ? _data['idInfoByIdType'][key]
                : {};
        }
      }
      if (_data['groupSetByType']) {
        this.groupSetByType = {} as any;
        for (let key in _data['groupSetByType']) {
          if (_data['groupSetByType'].hasOwnProperty(key))
            (<any>this.groupSetByType)![key] = _data['groupSetByType'][key]
              ? _data['groupSetByType'][key].map((i: any) => GroupSet.fromJS(i))
              : [];
        }
      }
      if (_data['groupSetsByID']) {
        this.groupSetsByID = {} as any;
        for (let key in _data['groupSetsByID']) {
          if (_data['groupSetsByID'].hasOwnProperty(key))
            (<any>this.groupSetsByID)![key] = _data['groupSetsByID'][key]
              ? GroupSet.fromJS(_data['groupSetsByID'][key])
              : new GroupSet();
        }
      }
      if (_data['groupsByID']) {
        this.groupsByID = {} as any;
        for (let key in _data['groupsByID']) {
          if (_data['groupsByID'].hasOwnProperty(key))
            (<any>this.groupsByID)![key] = _data['groupsByID'][key]
              ? Group.fromJS(_data['groupsByID'][key])
              : new Group();
        }
      }
      if (_data['axAccountDict']) {
        this.axAccountDict = {} as any;
        for (let key in _data['axAccountDict']) {
          if (_data['axAccountDict'].hasOwnProperty(key))
            (<any>this.axAccountDict)![key] = _data['axAccountDict'][key];
        }
      }
      if (_data['axAccountByCustomerID']) {
        this.axAccountByCustomerID = {} as any;
        for (let key in _data['axAccountByCustomerID']) {
          if (_data['axAccountByCustomerID'].hasOwnProperty(key))
            (<any>this.axAccountByCustomerID)![key] =
              _data['axAccountByCustomerID'][key];
        }
      }
      if (_data['employeeMainStationIDs']) {
        this.employeeMainStationIDs = {} as any;
        for (let key in _data['employeeMainStationIDs']) {
          if (_data['employeeMainStationIDs'].hasOwnProperty(key))
            (<any>this.employeeMainStationIDs)![key] =
              _data['employeeMainStationIDs'][key];
        }
      }
      if (_data['returnLocationsByID']) {
        this.returnLocationsByID = {} as any;
        for (let key in _data['returnLocationsByID']) {
          if (_data['returnLocationsByID'].hasOwnProperty(key))
            (<any>this.returnLocationsByID)![key] = _data[
              'returnLocationsByID'
            ][key]
              ? AssistReturnLocation.fromJS(_data['returnLocationsByID'][key])
              : new AssistReturnLocation();
        }
      }
      if (_data['stationReturnLocationsByStationID']) {
        this.stationReturnLocationsByStationID = {} as any;
        for (let key in _data['stationReturnLocationsByStationID']) {
          if (_data['stationReturnLocationsByStationID'].hasOwnProperty(key))
            (<any>this.stationReturnLocationsByStationID)![key] = _data[
              'stationReturnLocationsByStationID'
            ][key]
              ? _data['stationReturnLocationsByStationID'][key].map((i: any) =>
                  AssistStationReturnLocation.fromJS(i)
                )
              : [];
        }
      }
      if (_data['roleNamesByID']) {
        this.roleNamesByID = {} as any;
        for (let key in _data['roleNamesByID']) {
          if (_data['roleNamesByID'].hasOwnProperty(key))
            (<any>this.roleNamesByID)![key] = _data['roleNamesByID'][key];
        }
      }
      if (_data['stationCityNameByStationID']) {
        this.stationCityNameByStationID = {} as any;
        for (let key in _data['stationCityNameByStationID']) {
          if (_data['stationCityNameByStationID'].hasOwnProperty(key))
            (<any>this.stationCityNameByStationID)![key] =
              _data['stationCityNameByStationID'][key];
        }
      }
      if (Array.isArray(_data['activeStationIDs'])) {
        this.activeStationIDs = [] as any;
        for (let item of _data['activeStationIDs'])
          this.activeStationIDs!.push(item);
      }
      this.settings = _data['settings']
        ? SettingsModel.fromJS(_data['settings'])
        : new SettingsModel();
      if (_data['paramHeaders']) {
        this.paramHeaders = {} as any;
        for (let key in _data['paramHeaders']) {
          if (_data['paramHeaders'].hasOwnProperty(key))
            (<any>this.paramHeaders)![key] = _data['paramHeaders'][key];
        }
      }
      if (_data['calculationDescriptions']) {
        this.calculationDescriptions = {} as any;
        for (let key in _data['calculationDescriptions']) {
          if (_data['calculationDescriptions'].hasOwnProperty(key))
            (<any>this.calculationDescriptions)![key] =
              _data['calculationDescriptions'][key];
        }
      }
      if (_data['idTypeNames']) {
        this.idTypeNames = {} as any;
        for (let key in _data['idTypeNames']) {
          if (_data['idTypeNames'].hasOwnProperty(key))
            (<any>this.idTypeNames)![key] = _data['idTypeNames'][key];
        }
      }
    }
  }

  static fromJS(data: any): BasicDataModel {
    data = typeof data === 'object' ? data : {};
    let result = new BasicDataModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.idInfoByIdType) {
      data['idInfoByIdType'] = {};
      for (let key in this.idInfoByIdType) {
        if (this.idInfoByIdType.hasOwnProperty(key))
          (<any>data['idInfoByIdType'])[key] = this.idInfoByIdType[key];
      }
    }
    if (this.groupSetByType) {
      data['groupSetByType'] = {};
      for (let key in this.groupSetByType) {
        if (this.groupSetByType.hasOwnProperty(key))
          (<any>data['groupSetByType'])[key] = this.groupSetByType[key];
      }
    }
    if (this.groupSetsByID) {
      data['groupSetsByID'] = {};
      for (let key in this.groupSetsByID) {
        if (this.groupSetsByID.hasOwnProperty(key))
          (<any>data['groupSetsByID'])[key] = this.groupSetsByID[key]
            ? this.groupSetsByID[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.groupsByID) {
      data['groupsByID'] = {};
      for (let key in this.groupsByID) {
        if (this.groupsByID.hasOwnProperty(key))
          (<any>data['groupsByID'])[key] = this.groupsByID[key]
            ? this.groupsByID[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.axAccountDict) {
      data['axAccountDict'] = {};
      for (let key in this.axAccountDict) {
        if (this.axAccountDict.hasOwnProperty(key))
          (<any>data['axAccountDict'])[key] = this.axAccountDict[key];
      }
    }
    if (this.axAccountByCustomerID) {
      data['axAccountByCustomerID'] = {};
      for (let key in this.axAccountByCustomerID) {
        if (this.axAccountByCustomerID.hasOwnProperty(key))
          (<any>data['axAccountByCustomerID'])[
            key
          ] = this.axAccountByCustomerID[key];
      }
    }
    if (this.employeeMainStationIDs) {
      data['employeeMainStationIDs'] = {};
      for (let key in this.employeeMainStationIDs) {
        if (this.employeeMainStationIDs.hasOwnProperty(key))
          (<any>data['employeeMainStationIDs'])[
            key
          ] = this.employeeMainStationIDs[key];
      }
    }
    if (this.returnLocationsByID) {
      data['returnLocationsByID'] = {};
      for (let key in this.returnLocationsByID) {
        if (this.returnLocationsByID.hasOwnProperty(key))
          (<any>data['returnLocationsByID'])[key] = this.returnLocationsByID[
            key
          ]
            ? this.returnLocationsByID[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.stationReturnLocationsByStationID) {
      data['stationReturnLocationsByStationID'] = {};
      for (let key in this.stationReturnLocationsByStationID) {
        if (this.stationReturnLocationsByStationID.hasOwnProperty(key))
          (<any>data['stationReturnLocationsByStationID'])[
            key
          ] = this.stationReturnLocationsByStationID[key];
      }
    }
    if (this.roleNamesByID) {
      data['roleNamesByID'] = {};
      for (let key in this.roleNamesByID) {
        if (this.roleNamesByID.hasOwnProperty(key))
          (<any>data['roleNamesByID'])[key] = this.roleNamesByID[key];
      }
    }
    if (this.stationCityNameByStationID) {
      data['stationCityNameByStationID'] = {};
      for (let key in this.stationCityNameByStationID) {
        if (this.stationCityNameByStationID.hasOwnProperty(key))
          (<any>data['stationCityNameByStationID'])[
            key
          ] = this.stationCityNameByStationID[key];
      }
    }
    if (Array.isArray(this.activeStationIDs)) {
      data['activeStationIDs'] = [];
      for (let item of this.activeStationIDs)
        data['activeStationIDs'].push(item);
    }
    data['settings'] = this.settings ? this.settings.toJSON() : <any>undefined;
    if (this.paramHeaders) {
      data['paramHeaders'] = {};
      for (let key in this.paramHeaders) {
        if (this.paramHeaders.hasOwnProperty(key))
          (<any>data['paramHeaders'])[key] = this.paramHeaders[key];
      }
    }
    if (this.calculationDescriptions) {
      data['calculationDescriptions'] = {};
      for (let key in this.calculationDescriptions) {
        if (this.calculationDescriptions.hasOwnProperty(key))
          (<any>data['calculationDescriptions'])[
            key
          ] = this.calculationDescriptions[key];
      }
    }
    if (this.idTypeNames) {
      data['idTypeNames'] = {};
      for (let key in this.idTypeNames) {
        if (this.idTypeNames.hasOwnProperty(key))
          (<any>data['idTypeNames'])[key] = this.idTypeNames[key];
      }
    }
    return data;
  }
}

export interface IBasicDataModel {
  idInfoByIdType: {
    [key in keyof typeof IdType]?: { [key: string]: IdInfoModel };
  };
  groupSetByType: { [key in keyof typeof IdType]?: GroupSet[] };
  groupSetsByID: { [key: string]: GroupSet };
  groupsByID: { [key: string]: Group };
  axAccountDict: { [key: string]: number };
  axAccountByCustomerID: { [key: string]: string };
  employeeMainStationIDs: { [key: string]: number };
  returnLocationsByID: { [key: string]: AssistReturnLocation };
  stationReturnLocationsByStationID: {
    [key: string]: AssistStationReturnLocation[];
  };
  roleNamesByID: { [key: string]: string };
  stationCityNameByStationID: { [key: string]: string };
  activeStationIDs: number[];
  settings: SettingsModel;
  paramHeaders: { [key in keyof typeof ParamSelection]?: string };
  calculationDescriptions: {
    [key in keyof typeof ParamCalculationType]?: string;
  };
  idTypeNames: { [key in keyof typeof IdType]?: string };
}

export class IdInfoModel implements IIdInfoModel {
  idType!: IdType;
  id!: number;
  name!: string;

  constructor(data?: IIdInfoModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.idType = _data['idType'];
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): IdInfoModel {
    data = typeof data === 'object' ? data : {};
    let result = new IdInfoModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['idType'] = this.idType;
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IIdInfoModel {
  idType: IdType;
  id: number;
  name: string;
}

export class GroupSet implements IGroupSet {
  id!: number;
  createdUtc!: Date;
  modifiedUtc!: Date;
  createdByID!: number;
  modifiedByID!: number;
  idType!: IdType;
  setName!: string;
  isDisabled!: boolean;
  groups!: Group[];

  constructor(data?: IGroupSet) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.groups = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.createdUtc = _data['createdUtc']
        ? new Date(_data['createdUtc'].toString())
        : <any>undefined;
      this.modifiedUtc = _data['modifiedUtc']
        ? new Date(_data['modifiedUtc'].toString())
        : <any>undefined;
      this.createdByID = _data['createdByID'];
      this.modifiedByID = _data['modifiedByID'];
      this.idType = _data['idType'];
      this.setName = _data['setName'];
      this.isDisabled = _data['isDisabled'];
      if (Array.isArray(_data['groups'])) {
        this.groups = [] as any;
        for (let item of _data['groups']) this.groups!.push(Group.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GroupSet {
    data = typeof data === 'object' ? data : {};
    let result = new GroupSet();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['createdUtc'] = this.createdUtc
      ? this.createdUtc.toISOString()
      : <any>undefined;
    data['modifiedUtc'] = this.modifiedUtc
      ? this.modifiedUtc.toISOString()
      : <any>undefined;
    data['createdByID'] = this.createdByID;
    data['modifiedByID'] = this.modifiedByID;
    data['idType'] = this.idType;
    data['setName'] = this.setName;
    data['isDisabled'] = this.isDisabled;
    if (Array.isArray(this.groups)) {
      data['groups'] = [];
      for (let item of this.groups) data['groups'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGroupSet {
  id: number;
  createdUtc: Date;
  modifiedUtc: Date;
  createdByID: number;
  modifiedByID: number;
  idType: IdType;
  setName: string;
  isDisabled: boolean;
  groups: Group[];
}

export class Group implements IGroup {
  id!: number;
  createdUtc!: Date;
  createdByID!: number;
  modifiedUtc!: Date;
  modifiedByID!: number;
  groupSetID!: number;
  groupName!: string;
  groupItems!: GroupItem[];

  constructor(data?: IGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.groupItems = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.createdUtc = _data['createdUtc']
        ? new Date(_data['createdUtc'].toString())
        : <any>undefined;
      this.createdByID = _data['createdByID'];
      this.modifiedUtc = _data['modifiedUtc']
        ? new Date(_data['modifiedUtc'].toString())
        : <any>undefined;
      this.modifiedByID = _data['modifiedByID'];
      this.groupSetID = _data['groupSetID'];
      this.groupName = _data['groupName'];
      if (Array.isArray(_data['groupItems'])) {
        this.groupItems = [] as any;
        for (let item of _data['groupItems'])
          this.groupItems!.push(GroupItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Group {
    data = typeof data === 'object' ? data : {};
    let result = new Group();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['createdUtc'] = this.createdUtc
      ? this.createdUtc.toISOString()
      : <any>undefined;
    data['createdByID'] = this.createdByID;
    data['modifiedUtc'] = this.modifiedUtc
      ? this.modifiedUtc.toISOString()
      : <any>undefined;
    data['modifiedByID'] = this.modifiedByID;
    data['groupSetID'] = this.groupSetID;
    data['groupName'] = this.groupName;
    if (Array.isArray(this.groupItems)) {
      data['groupItems'] = [];
      for (let item of this.groupItems) data['groupItems'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGroup {
  id: number;
  createdUtc: Date;
  createdByID: number;
  modifiedUtc: Date;
  modifiedByID: number;
  groupSetID: number;
  groupName: string;
  groupItems: GroupItem[];
}

export class GroupItem implements IGroupItem {
  createdUtc!: Date;
  createdByID!: number;
  itemID!: number;
  groupID!: number;

  constructor(data?: IGroupItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdUtc = _data['createdUtc']
        ? new Date(_data['createdUtc'].toString())
        : <any>undefined;
      this.createdByID = _data['createdByID'];
      this.itemID = _data['itemID'];
      this.groupID = _data['groupID'];
    }
  }

  static fromJS(data: any): GroupItem {
    data = typeof data === 'object' ? data : {};
    let result = new GroupItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['createdUtc'] = this.createdUtc
      ? this.createdUtc.toISOString()
      : <any>undefined;
    data['createdByID'] = this.createdByID;
    data['itemID'] = this.itemID;
    data['groupID'] = this.groupID;
    return data;
  }
}

export interface IGroupItem {
  createdUtc: Date;
  createdByID: number;
  itemID: number;
  groupID: number;
}

export class AssistReturnLocation implements IAssistReturnLocation {
  returnLocationID!: number;
  returnLocationName!: string;
  city!: string;
  latitude!: number;
  longitude!: number;

  constructor(data?: IAssistReturnLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.returnLocationID = _data['returnLocationID'];
      this.returnLocationName = _data['returnLocationName'];
      this.city = _data['city'];
      this.latitude = _data['latitude'];
      this.longitude = _data['longitude'];
    }
  }

  static fromJS(data: any): AssistReturnLocation {
    data = typeof data === 'object' ? data : {};
    let result = new AssistReturnLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['returnLocationID'] = this.returnLocationID;
    data['returnLocationName'] = this.returnLocationName;
    data['city'] = this.city;
    data['latitude'] = this.latitude;
    data['longitude'] = this.longitude;
    return data;
  }
}

export interface IAssistReturnLocation {
  returnLocationID: number;
  returnLocationName: string;
  city: string;
  latitude: number;
  longitude: number;
}

export class AssistStationReturnLocation
  implements IAssistStationReturnLocation {
  stationReturnLocationID!: number;
  stationID!: number;
  returnLocationID!: number;
  validFromUtc?: Date | undefined;
  validToUtc?: Date | undefined;

  constructor(data?: IAssistStationReturnLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.stationReturnLocationID = _data['stationReturnLocationID'];
      this.stationID = _data['stationID'];
      this.returnLocationID = _data['returnLocationID'];
      this.validFromUtc = _data['validFromUtc']
        ? new Date(_data['validFromUtc'].toString())
        : <any>undefined;
      this.validToUtc = _data['validToUtc']
        ? new Date(_data['validToUtc'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): AssistStationReturnLocation {
    data = typeof data === 'object' ? data : {};
    let result = new AssistStationReturnLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['stationReturnLocationID'] = this.stationReturnLocationID;
    data['stationID'] = this.stationID;
    data['returnLocationID'] = this.returnLocationID;
    data['validFromUtc'] = this.validFromUtc
      ? this.validFromUtc.toISOString()
      : <any>undefined;
    data['validToUtc'] = this.validToUtc
      ? this.validToUtc.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IAssistStationReturnLocation {
  stationReturnLocationID: number;
  stationID: number;
  returnLocationID: number;
  validFromUtc?: Date | undefined;
  validToUtc?: Date | undefined;
}

export class SettingsModel implements ISettingsModel {
  buildSettings!: string;
  releaseVersion!: string;
  googleMapsApiKeyFrontend!: string;

  constructor(data?: ISettingsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.buildSettings = _data['buildSettings'];
      this.releaseVersion = _data['releaseVersion'];
      this.googleMapsApiKeyFrontend = _data['googleMapsApiKeyFrontend'];
    }
  }

  static fromJS(data: any): SettingsModel {
    data = typeof data === 'object' ? data : {};
    let result = new SettingsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['buildSettings'] = this.buildSettings;
    data['releaseVersion'] = this.releaseVersion;
    data['googleMapsApiKeyFrontend'] = this.googleMapsApiKeyFrontend;
    return data;
  }
}

export interface ISettingsModel {
  buildSettings: string;
  releaseVersion: string;
  googleMapsApiKeyFrontend: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
